export type UiLocale = 'en' | 'zh-TW' | 'zh-CN' | 'ja' | 'ko';

export type StringKey =
  | 'appName'
  | 'settings'
  | 'settingsClose'
  | 'settingsPosition'
  | 'settingsStyleMain'
  | 'settingsStyleSecond'
  | 'settingsPresets'
  | 'settingsLanguage'
  | 'settingsSubY'
  | 'settingsSeparation'
  | 'settingsSpacing'
  | 'settingsMaxWidth'
  | 'settingsFontSize'
  | 'settingsFontColor'
  | 'settingsFontWeight'
  | 'settingsStroke'
  | 'settingsOpacity'
  | 'settingsDarkMode'
  | 'settingsEngine'
  | 'settingsApplyPreset'
  | 'tracks'
  | 'signIn'
  | 'member'
  | 'account'
  | 'back'
  | 'settingsPractice'
  | 'settingsPracticeMode'
  | 'settingsPracticeWatch'
  | 'settingsPracticeDictation'
  | 'settingsPracticeSpeaking'
  | 'settingsPracticeShadowing'
  | 'settingsPracticeLearning'
  | 'settingsShadowingGrayPast'
  | 'settingsShadowingHideUpcoming'
  | 'settingsShadowingAutoRemoveLineBreaks'
  | 'settingsDictationSubtitle'
  | 'settingsDictationMain'
  | 'settingsDictationSecond'
  | 'settingsDictationFiltered'
  | 'settingsDictationIgnoreBrackets'
  | 'settingsDictationTypingVolume'
  | 'settingsDictationInputPosition'
  | 'settingsDictationPositionTop'
  | 'settingsDictationPositionBottom'
  | 'settingsSpeakingVolume'
  | 'settingsFurigana'
  | 'settingsFuriganaEnable'
  | 'settingsFuriganaConvert'
  | 'settingsFuriganaRomaji'
  | 'settingsReader'
  | 'settingsReaderEnable'
  | 'settingsReaderVoice'
  | 'settingsReaderVoiceDefault'
  | 'settingsReaderRate'
  | 'settingsReaderVolume'
  | 'settingsFontFamily'
  | 'settingsFontGoogleFamilies'
  | 'settingsFontGoogleCss'
  | 'settingsFontPreset'
  | 'settingsShadow'
  | 'settingsShadowColor'
  | 'settingsBackground'
  | 'settingsBackgroundOpacity'
  | 'settingsLetterSpacing'
  | 'settingsLineHeight'
  | 'settingsPadding'
  | 'settingsBoxShadow'
  | 'settingsStrokeColor'
  | 'settingsShadowNone'
  | 'settingsShadowRaised'
  | 'settingsShadowDepressed'
  | 'settingsShadowOutline'
  | 'settingsShadowShadow'
  | 'settingsBoxShadowNone'
  | 'settingsBoxShadowSoft'
  | 'settingsBoxShadowMedium'
  | 'settingsFontPresetNetflix'
  | 'settingsFontPresetArial'
  | 'settingsFontPresetVerdana'
  | 'settingsFontPresetTahoma'
  | 'settingsFontPresetTrebuchet'
  | 'settingsFontPresetTimes'
  | 'settingsFontPresetGeorgia'
  | 'settingsFontPresetGaramond'
  | 'settingsFontPresetCourier'
  | 'settingsFontPresetBrush'
  | 'settingsPreprocess'
  | 'settingsPreprocess1'
  | 'settingsPreprocess2'
  | 'settingsPreprocess3'
  | 'settingsEnableShortcuts'
  | 'settingsHoverToReveal'
  | 'settingsSubtitleList'
  | 'settingsDragHandle'
  | 'cuePanelTitle'
  | 'cuePanelSlot'
  | 'cuePanelMain'
  | 'cuePanelSecond'
  | 'cuePanelEmpty'
  | 'cueList'
  | 'settingsLearningTarget'
  | 'learnTargetNone'
  | 'learnTargetNotSet'
  | 'settingsLearningDefaultPrompt'
  | 'settingsLearningCardsLink'
  | 'settingsMainSubY'
  | 'settingsSecondSubY'
  | 'learnPromptMeaning'
  | 'learnPromptExamples'
  | 'learnPromptDictionary'
  | 'learnTtsRate'
  | 'learnTtsRateXslow'
  | 'learnTtsRateSlow'
  | 'learnTtsRateMedium'
  | 'learnUnsave'
  | 'learnLoading'
  | 'learnLoadingAi'
  | 'learnQuota'
  | 'learnTtsFailed'
  | 'learnSaveFailed'
  | 'learnSaving'
  | 'learnMembersSignIn'
  | 'learnMembersAi'
  | 'speakRecord'
  | 'speakStop'
  | 'speakReplay'
  | 'speakMic'
  | 'speakErrorSecure'
  | 'speakErrorPermission'
  | 'speakErrorUnsupported'
  | 'speakErrorUnknown'
  | 'cardsTitle'
  | 'cardsDeck'
  | 'cardsSort'
  | 'cardsUncategorized'
  | 'cardsDeckName'
  | 'cardsCreateDeck'
  | 'cardsRemoveDeck'
  | 'cardsDeleteCard'
  | 'cardsEditCard'
  | 'cardsExportCsv'
  | 'cardsSave'
  | 'cardsClose'
  | 'cardsFailed'
  | 'cardsFieldFront'
  | 'cardsFieldFrontTrans'
  | 'cardsFieldRefSent'
  | 'cardsFieldRefTrans'
  | 'cardsFieldFrontDesc'
  | 'cardsFieldBackDesc'
  | 'cardsEmpty'
  | 'cardsLoading'
  | 'cardsLoginRequired'
  | 'cardsDuplicate'
  | 'cardsRemoveDeckConfirm'
  | 'cardsRefresh'
  | 'cardsSortCreatedDesc'
  | 'cardsSortCreatedAsc'
  | 'cardsSortUpdatedDesc'
  | 'cardsSortUpdatedAsc'
  | 'shortcutSeekPrev'
  | 'shortcutSeekRepeat'
  | 'shortcutSeekNext'
  | 'shortcutDelayBothDown'
  | 'shortcutDelayBothUp'
  | 'shortcutDelayMainDown'
  | 'shortcutDelayMainUp'
  | 'shortcutDelaySecondDown'
  | 'shortcutDelaySecondUp'
  | 'shortcutToggleMain'
  | 'shortcutToggleSecond'
  | 'shortcutDualMain'
  | 'shortcutDualSecond'
  | 'shortcutCopy'
  | 'shortcutReader'
  | 'shortcutDictationHint'
  | 'shortcutDictationPlayWord'
  | 'shortcutSpeakingRecord'
  | 'shortcutSpeakingRecordToggle'
  | 'shortcutSpeakingReplay'
  | 'shortcutMic'
  | 'railSeekPrev'
  | 'railSeekRepeat'
  | 'railSeekNext'
  | 'railPlay'
  | 'railPause'
  | 'railDelayMain'
  | 'railDelaySecond'
  | 'railDelayDown'
  | 'railDelayUp'
  | 'railPosition'
  | 'railPositionSlider'
  | 'railFontSize'
  | 'railFontSizeSlider'
  | 'railCenter'
  | 'railCenterSlider'
  | 'railControls'
  | 'railPin'
  | 'langPickerPopular'
  | 'langPickerMore'
  | 'langPickerNone'
  | 'langPickerCustom'
  | 'langPickerCustomCode'
  | 'translateTo'
  | 'trackSelectLabel'
  | 'trackSelectPlaceholder'
  | 'trackHide'
  | 'trackLoading'
  | 'trackLoadFailed'
  | 'memberTrackHint'
  | 'trackSource'
  | 'trackSourceUpload'
  | 'trackSourceDemo'
  | 'trackAdvancedShow'
  | 'trackAdvancedHide'
  | 'trackEmpty'
  | 'trackChooseFile'
  | 'trackUploadCta'
  | 'trackAddFile'
  | 'trackSlotMain'
  | 'trackSlotSecond'
  | 'trackSlotSecondAdvanced'
  | 'trackTranslateMain'
  | 'trackTranslateSecond'
  | 'trackListing'
  | 'settingsTabSubs'
  | 'settingsTabPractice'
  | 'settingsTabLook'
  | 'settingsTabAdvanced'
  | 'practiceHintWatch'
  | 'practiceHintDictation'
  | 'practiceHintSpeaking'
  | 'practiceHintLearning'
  | 'practiceEnd'
  | 'translationStatusBusy'
  | 'translationStatusFailed'
  | 'translationQuota'
  | 'translationFailed'
  | 'translationMemberOnly'
  | 'serviceLoading'
  | 'serviceQueuing'
  | 'serviceGenerating'
  | 'serviceDownloading'
  | 'serviceEnhanced'
  | 'serviceMemberOnly'
  | 'serviceDismissUnknown'
  | 'serviceDismissInfo'
  | 'serviceDismissLength'
  | 'serviceDismissLive'
  | 'serviceDismissSource'
  | 'serviceDismissEnhance'
  | 'serviceDismissEnhanceTimeout'
  | 'serviceDismissUpstream'
  | 'serviceDismissCancelled'
  | 'hoverRevealShow'
  | 'cardsSignInCta'
  | 'more'
  | 'learnSave'
  | 'learnSaved'
  | 'learnPin'
  | 'learnUnpin'
  | 'learnMove'
  | 'learnSpeak'
  | 'learnMembersOnly'
  | 'recentWatches'
  | 'recentWatchOpen'
  | 'subtitleLoadStatus'
  | 'subtitleLoadListing'
  | 'subtitleLoadDownloading'
  | 'practiceWaitingPlayer'
  | 'trackLoadProgress'
  | 'practiceNavPrev'
  | 'practiceNavReplay'
  | 'practiceNavNext'
  | 'dictationPlaceholder'
  | 'dictationPlaceholderSpeaking'
  | 'dictationTapToType'
  | 'dictationTapToSpeak'
  | 'dictationTapToShadow'
  | 'dictationDone'
  | 'stageOpenTracks'
  | 'stageOpenSettings'
  | 'stagePickTranslateLang'
  | 'stageRetryLoad'
  | 'stageSignIn'
  | 'stageDismiss'
  | 'stageBilingualSummary'
  | 'practiceOpen'
  | 'memberTrackLabel'
  | 'exportSrt'
  | 'exportSrtMain'
  | 'exportSrtSecond'
  | 'exportSrtDone'
  | 'exportSrtNeedTrack'
  | 'importSrt'
  | 'importSrtMain'
  | 'importSrtSecond'
  | 'importSrtUpload'
  | 'importSrtUploaded'
  | 'settingsStyleCopy'
  | 'settingsStyleCopyFromSecond'
  | 'settingsStyleCopyFromMain'
  | 'settingsStyleResetTrack'
  | 'settingsStyleSlotMain'
  | 'settingsStyleSlotSecond'
  | 'landingWebDiff'
  | 'landingTagline'
  | 'landingUrlLabel'
  | 'landingOpen'
  | 'landingUrlInvalid'
  | 'landingTrySample'
  | 'loginWebDiff'
  | 'loginEmailTitle'
  | 'loginEmailDesc'
  | 'loginEmailLabel'
  | 'loginSendCode'
  | 'loginSending'
  | 'loginCodeLabel'
  | 'loginSubmit'
  | 'loginSubmitting'
  | 'loginOr'
  | 'loginPatreon'
  | 'loginPatreonNote'
  | 'loginLogout'
  | 'memberStatusPrefix'
  | 'memberStatusActive'
  | 'memberStatusInactive'
  | 'memberStatusSessionExpired'
  | 'memberStatusCheckFailed'
  | 'memberStatusSignedIn'
  | 'loginMsgSignedIn'
  | 'loginMsgInactive'
  | 'loginMsgSessionExpired'
  | 'loginMsgEmailSent'
  | 'loginMsgInvalidCode'
  | 'loginMsgNotSubscriber'
  | 'loginMsgQuotaExceeded'
  | 'loginMsgRateLimited'
  | 'loginMsgEnterEmail'
  | 'loginMsgNetworkError'
  | 'settingsMembersSuffix'
  | 'settingsDocs'
  | 'settingsDocsOpen'
  | 'settingsStylePreview'
  | 'settingsStylePreviewHint'
  | 'settingsResetAll'
  | 'cuePanelLock'
  | 'cuePanelUnlock'
  | 'cuePanelResize'
  | 'settingsSelectable'
  | 'settingsSubtitleOptimize'
  | 'settingsSubtitleOptimizeEnable'
  | 'settingsSubtitleOptimizeModel'
  | 'settingsSubtitleOptimizeModelAuto'
  | 'settingsSubtitleOptimizeModelSmall'
  | 'settingsSubtitleOptimizeModelLarge'
  | 'learnCopy'
  | 'loginCallbackWorking'
  | 'loginCallbackOk'
  | 'loginCallbackFail'
  | 'loginCallbackContinue'
  | 'styleStudioTitle'
  | 'styleStudioOpen'
  | 'styleStudioApplied'
  | 'styleStudioApplyScope'
  | 'styleStudioScopeBoth'
  | 'styleStudioScopeMain'
  | 'styleStudioScopeSecond'
  | 'styleStudioCustoms'
  | 'styleStudioCustomsEmpty'
  | 'styleStudioCustomName'
  | 'styleStudioSave'
  | 'styleStudioDelete'
  | 'styleStudioGoogleFonts'
  | 'styleStudioGoogleSearch'
  | 'styleStudioGooglePick'
  | 'styleStudioGoogleLoading'
  | 'styleStudioGoogleClear'
  | 'styleStudioGoogleCurrent'
  | 'styleStudioGoogleNone'
  | 'styleStudioGoogleSubset'
  | 'styleStudioGoogleSubsetAll'
  | 'styleStudioGoogleNeedFilter'
  | 'styleStudioGoogleLoadMore'
  | 'styleStudioLangBind'
  | 'styleStudioLangBindHint'
  | 'styleStudioLangBindNeedCustom'
  | 'styleStudioLangBindSelectCustom'
  | 'styleStudioLangSearch'
  | 'styleStudioLangConflict'
  | 'styleStudioLangBindEmpty'
  | 'styleStudioBindAdd'
  | 'styleStudioBindRemove';

const EN: Record<StringKey, string> = {
  appName: 'RikoSub',
  settings: 'Settings',
  settingsClose: 'Close',
  settingsPosition: 'Subtitle position',
  settingsStyleMain: 'Font - Primary',
  settingsStyleSecond: 'Font - Secondary',
  settingsPresets: 'Presets',
  settingsLanguage: 'UI language',
  settingsSubY: 'Subtitle position',
  settingsSeparation: 'Separate subtitle display',
  settingsSpacing: 'Spacing',
  settingsMaxWidth: 'Max width',
  settingsFontSize: 'Font size',
  settingsFontColor: 'Font color',
  settingsFontWeight: 'Font weight',
  settingsStroke: 'Stroke width',
  settingsOpacity: 'Opacity',
  settingsDarkMode: 'Dark mode',
  settingsEngine: 'Translation engine',
  settingsApplyPreset: 'Apply',
  tracks: 'Tracks',
  signIn: 'Login',
  member: 'Member',
  account: 'Account',
  back: 'Back',
  settingsPractice: 'Practice',
  settingsPracticeMode: 'Mode',
  settingsPracticeWatch: 'Watch',
  settingsPracticeDictation: 'Dictation',
  settingsPracticeSpeaking: 'Speaking',
  settingsPracticeShadowing: 'Shadowing',
  settingsPracticeLearning: 'Learning',
  settingsShadowingGrayPast: 'Gray past',
  settingsShadowingHideUpcoming: 'Hide ahead',
  settingsShadowingAutoRemoveLineBreaks: 'Auto remove line breaks',
  settingsDictationSubtitle: 'Main / Secondary',
  settingsDictationMain: 'Main',
  settingsDictationSecond: 'Secondary',
  settingsDictationFiltered: 'Filtered words',
  settingsDictationIgnoreBrackets: 'Ignore bracketed text',
  settingsDictationTypingVolume: 'Typing sound volume',
  settingsDictationInputPosition: 'Input position',
  settingsDictationPositionTop: 'Top',
  settingsDictationPositionBottom: 'Bottom',
  settingsSpeakingVolume: 'Playback volume',
  settingsFurigana: 'Furigana',
  settingsFuriganaEnable: 'Enable',
  settingsFuriganaConvert: 'Convert to',
  settingsFuriganaRomaji: 'Romaji',
  settingsReader: 'Subtitle reader',
  settingsReaderEnable: 'Enable',
  settingsReaderVoice: 'Voice',
  settingsReaderVoiceDefault: 'Auto',
  settingsReaderRate: 'Rate',
  settingsReaderVolume: 'Volume',
  settingsFontFamily: 'Font families',
  settingsFontGoogleFamilies: 'Google Fonts (Font families)',
  settingsFontGoogleCss: 'Google Fonts (CSS properties)',
  settingsFontPreset: 'Font families',
  settingsShadow: 'Shadow',
  settingsShadowColor: 'Shadow color',
  settingsBackground: 'Background color',
  settingsBackgroundOpacity: 'Background opacity',
  settingsLetterSpacing: 'Letter spacing',
  settingsLineHeight: 'Line height',
  settingsPadding: 'Padding',
  settingsBoxShadow: 'Box shadow',
  settingsStrokeColor: 'Stroke color',
  settingsShadowNone: 'None',
  settingsShadowRaised: 'Raised',
  settingsShadowDepressed: 'Depressed',
  settingsShadowOutline: 'Outline',
  settingsShadowShadow: 'Shadow',
  settingsBoxShadowNone: 'None',
  settingsBoxShadowSoft: 'Soft',
  settingsBoxShadowMedium: 'Medium',
  settingsFontPresetNetflix: 'Netflix Sans',
  settingsFontPresetArial: 'Arial',
  settingsFontPresetVerdana: 'Verdana',
  settingsFontPresetTahoma: 'Tahoma',
  settingsFontPresetTrebuchet: 'Trebuchet MS',
  settingsFontPresetTimes: 'Times New Roman',
  settingsFontPresetGeorgia: 'Georgia',
  settingsFontPresetGaramond: 'Garamond',
  settingsFontPresetCourier: 'Courier New',
  settingsFontPresetBrush: 'Brush Script MT',
  settingsPreprocess: 'Subtitle pre-processing',
  settingsPreprocess1: 'Remove line breaks',
  settingsPreprocess2: 'Remove text in brackets',
  settingsPreprocess3: 'Merge adjacent subtitles with the same timing',
  settingsEnableShortcuts: 'Shortcuts',
  settingsHoverToReveal: 'Hover to reveal subtitles',
  settingsSubtitleList: 'Subtitle list',
  settingsDragHandle: 'Subtitle position',
  cuePanelTitle: 'Subtitle list',
  cuePanelSlot: 'Slot',
  cuePanelMain: 'Main',
  cuePanelSecond: 'Secondary',
  cuePanelEmpty: 'Please select a subtitle option.',
  cueList: 'Subtitle list',
  settingsLearningTarget: 'Target language',
  learnTargetNone: '-',
  learnTargetNotSet: 'Set a target language in Settings → Practice → Learning.',
  settingsLearningDefaultPrompt: 'Default prompt',
  settingsLearningCardsLink: 'Link',
  settingsMainSubY: 'Subtitle position (main)',
  settingsSecondSubY: 'Subtitle position (second)',
  learnPromptMeaning: 'Brief explanation',
  learnPromptExamples: 'Five examples',
  learnPromptDictionary: 'Dictionary',
  learnTtsRate: 'Rate',
  learnTtsRateXslow: 'x-slow',
  learnTtsRateSlow: 'slow',
  learnTtsRateMedium: 'medium',
  learnUnsave: 'Remove card',
  learnLoading: 'Loading...',
  learnLoadingAi: 'Loading...',
  learnQuota: 'Quota limit reached',
  learnTtsFailed: 'Failed',
  learnSaveFailed: 'Error',
  learnSaving: 'Saving…',
  learnMembersSignIn: 'Members-only feature',
  learnMembersAi: 'Members-only feature',
  speakRecord: 'Record',
  speakStop: 'Stop',
  speakReplay: 'Replay take',
  speakMic: 'Mic',
  speakErrorSecure:
    'Microphone needs HTTPS. Open this page over a secure connection (or localhost).',
  speakErrorPermission: 'Microphone permission denied.',
  speakErrorUnsupported: 'Recording is not supported in this browser.',
  speakErrorUnknown: 'Could not access the microphone.',
  practiceNavPrev: 'Prev',
  practiceNavReplay: 'Replay',
  practiceNavNext: 'Next',
  cardsTitle: 'Saved cards',
  cardsDeck: 'Deck',
  cardsSort: 'Sort',
  cardsUncategorized: 'Uncategorized',
  cardsDeckName: 'Deck Name',
  cardsCreateDeck: 'Create Deck',
  cardsRemoveDeck: 'Remove Deck',
  cardsDeleteCard: 'Delete',
  cardsEditCard: 'Update Card',
  cardsExportCsv: 'Export cards (CSV)',
  cardsSave: 'Submit',
  cardsClose: 'Close',
  cardsFailed: 'Error',
  cardsFieldFront: 'Front',
  cardsFieldFrontTrans: 'Front translation',
  cardsFieldRefSent: 'Reference sentence',
  cardsFieldRefTrans: 'Reference translation',
  cardsFieldFrontDesc: 'Front note',
  cardsFieldBackDesc: 'Back note',
  cardsEmpty: 'No cards in this deck.',
  cardsLoading: 'Loading...',
  cardsLoginRequired: 'Please log in as a member to view saved cards.',
  cardsDuplicate: 'Same deck already exists',
  cardsRemoveDeckConfirm: 'Remove this deck? Cards in it will be deleted.',
  cardsRefresh: 'Refresh',
  cardsSortCreatedDesc: 'Created Date ↓',
  cardsSortCreatedAsc: 'Created Date ↑',
  cardsSortUpdatedDesc: 'Updated Date ↓',
  cardsSortUpdatedAsc: 'Updated Date ↑',
  shortcutSeekPrev: 'Previous subtitle',
  shortcutSeekRepeat: 'Repeat subtitle',
  shortcutSeekNext: 'Next subtitle',
  shortcutDelayBothDown: 'Slow down subtitle',
  shortcutDelayBothUp: 'Speed up subtitle',
  shortcutDelayMainDown: 'Slow down subtitle (primary subtitle)',
  shortcutDelayMainUp: 'Speed up subtitle (primary subtitle)',
  shortcutDelaySecondDown: 'Slow down subtitle (secondary subtitle)',
  shortcutDelaySecondUp: 'Speed up subtitle (secondary subtitle)',
  shortcutToggleMain: 'Toggle primary subtitle',
  shortcutToggleSecond: 'Toggle secondary subtitle',
  shortcutDualMain: 'Show Original & Translation（primary subtitle）',
  shortcutDualSecond: 'Show Original & Translation（secondary subtitle）',
  shortcutCopy: 'Copy selected text',
  shortcutReader: 'Subtitle reader',
  shortcutDictationHint: 'Hint',
  shortcutDictationPlayWord: 'Play from current word',
  shortcutSpeakingRecord: 'Record (Hold)',
  shortcutSpeakingRecordToggle: 'Record (Toggle)',
  shortcutSpeakingReplay: 'Replay recording',
  shortcutMic: 'Mic monitoring',
  railSeekPrev: 'Previous subtitle',
  railSeekRepeat: 'Repeat subtitle',
  railSeekNext: 'Next subtitle',
  railPlay: 'Play',
  railPause: 'Pause',
  railDelayMain: 'Main subtitle delay',
  railDelaySecond: 'Secondary subtitle delay',
  railDelayDown: 'Subtitle earlier (−0.1s)',
  railDelayUp: 'Subtitle later (+0.1s)',
  railPosition: 'Subtitle position',
  railPositionSlider: 'Subtitle position',
  railFontSize: 'Font size',
  railFontSizeSlider: 'Font size',
  railCenter: 'Center line',
  railCenterSlider: 'Center line',
  railControls: 'Controls',
  railPin: 'Pin controls',
  langPickerPopular: 'Popular languages',
  langPickerMore: 'More languages',
  langPickerNone: 'No translation',
  langPickerCustom: 'Custom code…',
  langPickerCustomCode: 'Language code',
  translateTo: 'Translate to',
  trackSelectLabel: 'Track',
  trackSelectPlaceholder: 'Please select a subtitle option.',
  trackHide: 'Hide primary subtitle',
  trackLoading: 'Loading...',
  trackLoadFailed: 'Failed to load track',
  memberTrackHint: 'Members-only feature',
  trackSource: 'Source',
  trackSourceUpload: 'Upload',
  trackSourceDemo: 'Demo fixtures',
  trackAdvancedShow: 'Show advanced…',
  trackAdvancedHide: 'Hide advanced',
  trackEmpty:
    'No subtitle tracks for this video — import a file in Settings (.vtt / .srt / .json3).',
  trackChooseFile: 'Upload',
  trackUploadCta: 'Import subtitles',
  trackAddFile: 'Import subtitles',
  trackSlotMain: 'Main Subtitles',
  trackSlotSecond: 'Secondary Subtitles',
  trackSlotSecondAdvanced: 'Second track (advanced)',
  trackTranslateMain: 'Main Subtitles',
  trackTranslateSecond: 'Secondary Subtitles',
  trackListing: 'Loading...',
  settingsTabSubs: 'Subtitles',
  settingsTabPractice: 'Practice',
  settingsTabLook: 'Look',
  settingsTabAdvanced: 'Other',
  practiceHintWatch: 'Normal dual subtitles. Use Selectable above to copy text.',
  practiceHintDictation:
    'Type what you hear. Playback pauses at the end of each cue until you finish.',
  practiceHintSpeaking: 'Speak each line aloud, then check your take.',
  practiceHintLearning: 'Select words to look up and save cards.',
  practiceEnd: 'End practice',
  translationStatusBusy: 'Generating (#)...',
  translationStatusFailed: 'Failed',
  translationQuota: 'Quota limit reached',
  translationFailed: 'Failed',
  translationMemberOnly: 'Member only feature',
  serviceLoading: 'Loading...',
  serviceQueuing: 'Queuing (#) (@)...',
  serviceGenerating: 'Generating (#)...',
  serviceDownloading: 'Downloading...',
  serviceEnhanced: 'Segmentation',
  serviceMemberOnly: 'Members-only feature',
  serviceDismissUnknown: 'Something went wrong — try again',
  serviceDismissInfo: "Couldn't get captions for this video",
  serviceDismissLength: 'This video is too long',
  serviceDismissLive: "Live streams aren't supported",
  serviceDismissSource: 'Generate or enhance the source track first',
  serviceDismissEnhance: 'Enhancement failed — try again',
  serviceDismissEnhanceTimeout: 'Enhancement timed out — try again',
  serviceDismissUpstream: 'Something went wrong on the server — try again',
  serviceDismissCancelled: 'Cancelled',
  hoverRevealShow: 'Hover to reveal subtitles',
  cardsSignInCta: 'Login',
  more: 'Other',
  learnSave: 'Save',
  learnSaved: 'Saved',
  learnPin: 'Pin',
  learnUnpin: 'Unpin',
  learnMove: 'Move',
  learnSpeak: 'Speak',
  learnMembersOnly: 'Members-only feature',
  recentWatches: 'Recent',
  recentWatchOpen: 'Open',
  subtitleLoadStatus: 'Loading...',
  subtitleLoadListing: 'Loading...',
  subtitleLoadDownloading: 'Downloading...',
  practiceWaitingPlayer: 'Waiting for player… Practice controls appear when the video is ready.',
  trackLoadProgress: 'Progress',
  dictationPlaceholder: 'Type what you hear…',
  dictationPlaceholderSpeaking: 'Speak, then check your take…',
  dictationTapToType: 'Tap to start typing',
  dictationTapToSpeak: 'Tap to start speaking',
  dictationTapToShadow: 'Tap to start shadowing',
  dictationDone: 'Done',
  stageOpenTracks: 'Open tracks',
  stageOpenSettings: 'Open settings',
  stagePickTranslateLang: 'Choose a translation language for dual subtitles.',
  stageRetryLoad: 'Retry',
  stageSignIn: 'Sign in',
  stageDismiss: 'Dismiss',
  stageBilingualSummary: 'Dual · {lang}',
  practiceOpen: 'Watch',
  memberTrackLabel: 'Members-only feature',
  exportSrt: 'Export subtitles',
  exportSrtMain: 'Main subtitle',
  exportSrtSecond: 'Secondary subtitle',
  exportSrtDone: 'Download',
  exportSrtNeedTrack: 'Select a subtitle track first.',
  importSrt: 'Import subtitles',
  importSrtMain: 'Main subtitle',
  importSrtSecond: 'Secondary subtitle',
  importSrtUpload: 'Upload',
  importSrtUploaded: 'Uploaded Subtitles',
  settingsStyleCopy: 'Copy primary style',
  settingsStyleCopyFromSecond: 'Copy secondary style',
  settingsStyleCopyFromMain: 'Copy primary style',
  settingsStyleResetTrack: 'Reset to defaults',
  settingsStyleSlotMain: 'main',
  settingsStyleSlotSecond: 'second',
  landingWebDiff:
    'Same bilingual Tracks as the extension. Subtitles via secure proxy · sign in with email · not injected into youtube.com.',
  landingTagline: 'Bilingual subtitles for YouTube on mobile.',
  landingUrlLabel: 'YouTube link',
  landingOpen: 'Open video',
  landingUrlInvalid: 'Enter a valid YouTube URL or video id.',
  landingTrySample: 'Try a sample video',
  loginWebDiff:
    'Sign in with the email linked to your membership to unlock member features.',
  loginEmailTitle: 'Login with verification code',
  loginEmailDesc:
    'Enter the email used for your Patreon membership. We will send a one-time code (check spam).',
  loginEmailLabel: 'Email address',
  loginSendCode: 'Send code',
  loginSending: 'Sending…',
  loginCodeLabel: 'Verification code',
  loginSubmit: 'Login',
  loginSubmitting: 'Logging in…',
  loginOr: 'or',
  loginPatreon: 'Login with Patreon',
  loginPatreonNote:
    'Opens Patreon in a new tab. If membership does not return here, use email verification above.',
  loginLogout: 'Logout',
  memberStatusPrefix: 'Member status:',
  memberStatusActive: 'Active',
  memberStatusInactive: 'Inactive',
  memberStatusSessionExpired: 'Session expired — please log in again',
  memberStatusCheckFailed: 'Failed',
  memberStatusSignedIn: 'Signed in',
  loginMsgSignedIn: 'Signed in.',
  loginMsgInactive: 'Signed in — membership inactive.',
  loginMsgSessionExpired: 'Signed in — session expired. Please sign in again.',
  loginMsgEmailSent: 'Email sent. Check your inbox (and spam).',
  loginMsgInvalidCode: 'Invalid or used code.',
  loginMsgNotSubscriber: 'Not a subscriber (email not registered).',
  loginMsgQuotaExceeded: 'Usage exceeded. Try again later.',
  loginMsgRateLimited: 'Too many requests. Please wait ~30 seconds.',
  loginMsgEnterEmail: 'Please enter your email.',
  loginMsgNetworkError: 'Network or server error.',
  settingsMembersSuffix: ' (members)',
  settingsDocs: 'Documentation',
  settingsDocsOpen: 'Documentation',
  settingsStylePreview: 'Preview',
  settingsStylePreviewHint: 'Main + second · updates as you edit',
  settingsResetAll: 'Reset',
  cuePanelLock: 'Follow playback',
  cuePanelUnlock: 'Unlock scroll',
  cuePanelResize: 'Resize cue list',
  settingsSelectable: 'Make subtitles selectable',
  settingsSubtitleOptimize: 'AI Segmentation',
  settingsSubtitleOptimizeEnable: 'Enable',
  settingsSubtitleOptimizeModel: 'Model',
  settingsSubtitleOptimizeModelAuto: 'Auto',
  settingsSubtitleOptimizeModelSmall: 'Small',
  settingsSubtitleOptimizeModelLarge: 'Large',
  learnCopy: 'Copy selected text',
  loginCallbackWorking: 'Finishing Patreon sign-in…',
  loginCallbackOk: 'Signed in. Returning…',
  loginCallbackFail:
    'Could not read login credentials from this page. Use email verification, or register this redirect URI with Patreon.',
  loginCallbackContinue: 'Continue',
  styleStudioTitle: 'Subtitle Style Studio',
  styleStudioOpen: 'Open Style Studio',
  styleStudioApplied: 'Style applied.',
  styleStudioApplyScope: 'Apply to',
  styleStudioScopeBoth: 'Both',
  styleStudioScopeMain: 'Primary',
  styleStudioScopeSecond: 'Secondary',
  styleStudioCustoms: 'My style',
  styleStudioCustomsEmpty: 'No custom styles yet — save the current main track look.',
  styleStudioCustomName: 'Style name',
  styleStudioSave: 'Save style',
  styleStudioDelete: 'Delete',
  styleStudioGoogleFonts: 'Google Fonts',
  styleStudioGoogleSearch: 'Search fonts',
  styleStudioGooglePick: 'Search fonts',
  styleStudioGoogleLoading: 'Loading...',
  styleStudioGoogleClear: 'Clear Google Font',
  styleStudioGoogleCurrent: 'Current',
  styleStudioGoogleNone: 'No Google Font on this track (system/family only).',
  styleStudioGoogleSubset: 'Language',
  styleStudioGoogleSubsetAll: 'All',
  styleStudioGoogleNeedFilter: 'Choose a language subset or search to list fonts.',
  styleStudioGoogleLoadMore: 'Load more',
  styleStudioLangBind: 'Styles by language',
  styleStudioLangBindHint:
    'When a subtitle track matches one of these languages, its custom style is applied on the video automatically.',
  styleStudioLangBindNeedCustom: 'Save a custom style first, then bind languages here.',
  styleStudioLangBindSelectCustom: 'Select a custom style above to edit language bindings.',
  styleStudioLangSearch: 'Search languages',
  styleStudioLangConflict: 'Already used by "{name}".',
  styleStudioLangBindEmpty: 'No language bindings yet.',
  styleStudioBindAdd: 'Bind',
  styleStudioBindRemove: 'Remove',
};

const ZH_TW: Record<StringKey, string> = {
  appName: 'RikoSub',
  settings: '設定',
  settingsClose: '關閉',
  settingsPosition: '字幕位置',
  settingsStyleMain: '主字幕',
  settingsStyleSecond: '副字幕',
  settingsPresets: '預設樣式',
  settingsLanguage: '介面語言',
  settingsSubY: '字幕位置',
  settingsSeparation: '字幕分離顯示',
  settingsSpacing: '字幕間距',
  settingsMaxWidth: '最大寬度',
  settingsFontSize: '字體大小',
  settingsFontColor: '字體顏色',
  settingsFontWeight: '字體粗細',
  settingsStroke: '字體描邊寬度',
  settingsOpacity: '不透明度',
  settingsDarkMode: '夜間模式',
  settingsEngine: '翻譯引擎',
  settingsApplyPreset: '套用',
  tracks: '字幕軌',
  signIn: '登入',
  member: '會員',
  account: '帳號',
  back: '返回',
  settingsPractice: '練習',
  settingsPracticeMode: '模式',
  settingsPracticeWatch: '觀看',
  settingsPracticeDictation: '聽寫',
  settingsPracticeSpeaking: '口說',
  settingsPracticeShadowing: '跟讀',
  settingsPracticeLearning: '學習',
  settingsShadowingGrayPast: '已讀變灰',
  settingsShadowingHideUpcoming: '提前隱藏',
  settingsShadowingAutoRemoveLineBreaks: '自動啟用移除換行',
  settingsDictationSubtitle: '主要 / 次要',
  settingsDictationMain: '主要',
  settingsDictationSecond: '次要',
  settingsDictationFiltered: '過濾詞彙',
  settingsDictationIgnoreBrackets: '忽略括號及其內容',
  settingsDictationTypingVolume: '按鍵音量',
  settingsDictationInputPosition: '輸入欄位置',
  settingsDictationPositionTop: '上方',
  settingsDictationPositionBottom: '下方',
  settingsSpeakingVolume: '播放音量',
  settingsFurigana: '振假名',
  settingsFuriganaEnable: '啟用',
  settingsFuriganaConvert: '轉換為',
  settingsFuriganaRomaji: '羅馬拼音',
  settingsReader: '字幕朗讀器',
  settingsReaderEnable: '啟用',
  settingsReaderVoice: '語音',
  settingsReaderVoiceDefault: '自動',
  settingsReaderRate: '語速',
  settingsReaderVolume: '音量',
  settingsFontFamily: '字型',
  settingsFontGoogleFamilies: 'Google 字型（Font families）',
  settingsFontGoogleCss: 'Google 字型（CSS properties）',
  settingsFontPreset: '字型',
  settingsShadow: '陰影',
  settingsShadowColor: '陰影顏色',
  settingsBackground: '背景顏色',
  settingsBackgroundOpacity: '背景透明度',
  settingsLetterSpacing: '字距',
  settingsLineHeight: '行高',
  settingsPadding: '內距',
  settingsBoxShadow: '底框陰影',
  settingsStrokeColor: '字體描邊顏色',
  settingsShadowNone: '無',
  settingsShadowRaised: '浮凸',
  settingsShadowDepressed: '內凹',
  settingsShadowOutline: '外框',
  settingsShadowShadow: '陰影',
  settingsBoxShadowNone: '無',
  settingsBoxShadowSoft: '柔和',
  settingsBoxShadowMedium: '中等',
  settingsFontPresetNetflix: 'Netflix Sans',
  settingsFontPresetArial: 'Arial',
  settingsFontPresetVerdana: 'Verdana',
  settingsFontPresetTahoma: 'Tahoma',
  settingsFontPresetTrebuchet: 'Trebuchet MS',
  settingsFontPresetTimes: 'Times New Roman',
  settingsFontPresetGeorgia: 'Georgia',
  settingsFontPresetGaramond: 'Garamond',
  settingsFontPresetCourier: 'Courier New',
  settingsFontPresetBrush: 'Brush Script MT',
  settingsPreprocess: '字幕預處理',
  settingsPreprocess1: '移除換行',
  settingsPreprocess2: '移除括號內的文字',
  settingsPreprocess3: '合併時間相同的相鄰字幕',
  settingsEnableShortcuts: '快捷鍵',
  settingsHoverToReveal: '字幕懸停顯示',
  settingsSubtitleList: '字幕列表',
  settingsDragHandle: '字幕位置',
  cuePanelTitle: '字幕列表',
  cuePanelSlot: '軌道',
  cuePanelMain: '主要',
  cuePanelSecond: '次要',
  cuePanelEmpty: '請選擇一個字幕選項。',
  cueList: '字幕列表',
  settingsLearningTarget: '目標語言',
  learnTargetNone: '-',
  learnTargetNotSet: '請先在設定 → 練習 → 學習模式中選擇目標語言。',
  settingsLearningDefaultPrompt: '預設提示詞',
  settingsLearningCardsLink: '連結',
  settingsMainSubY: '字幕位置（主字幕）',
  settingsSecondSubY: '字幕位置（副字幕）',
  learnPromptMeaning: '簡要說明',
  learnPromptExamples: '五個例子',
  learnPromptDictionary: '詞典',
  learnTtsRate: '語速',
  learnTtsRateXslow: '極慢',
  learnTtsRateSlow: '慢',
  learnTtsRateMedium: '中等',
  learnUnsave: '移除卡片',
  learnLoading: '載入中...',
  learnLoadingAi: '載入中...',
  learnQuota: '已達到配額限制',
  learnTtsFailed: '失敗',
  learnSaveFailed: '錯誤',
  learnSaving: '儲存中…',
  learnMembersSignIn: '會員專屬功能',
  learnMembersAi: '會員專屬功能',
  speakRecord: '錄音',
  speakStop: '停止',
  speakReplay: '重播錄音',
  speakMic: '監聽',
  speakErrorSecure: '麥克風需要 HTTPS。請用安全連線（或 localhost）開啟此頁。',
  speakErrorPermission: '無法使用麥克風（權限被拒）。',
  speakErrorUnsupported: '此瀏覽器不支援錄音。',
  speakErrorUnknown: '無法存取麥克風。',
  practiceNavPrev: '上一句',
  practiceNavReplay: '重播',
  practiceNavNext: '下一句',
  cardsTitle: '已儲存卡片',
  cardsDeck: '分類',
  cardsSort: '排序',
  cardsUncategorized: '未分類',
  cardsDeckName: '分類名',
  cardsCreateDeck: '建立分類',
  cardsRemoveDeck: '移除分類',
  cardsDeleteCard: '刪除',
  cardsEditCard: '更新卡片',
  cardsExportCsv: '匯出卡片 (CSV)',
  cardsSave: '提交',
  cardsClose: '關閉',
  cardsFailed: '錯誤',
  cardsFieldFront: '正面',
  cardsFieldFrontTrans: '正面翻譯',
  cardsFieldRefSent: '例句',
  cardsFieldRefTrans: '例句翻譯',
  cardsFieldFrontDesc: '正面註記',
  cardsFieldBackDesc: '背面註記',
  cardsEmpty: '此分類尚無卡片。',
  cardsLoading: '載入中...',
  cardsLoginRequired: '請先登入會員以查看已儲存的卡片。',
  cardsDuplicate: '已有相同的分類',
  cardsRemoveDeckConfirm: '確定移除此分類？其中的卡片也會一併刪除。',
  cardsRefresh: '重新整理',
  cardsSortCreatedDesc: '創建日期 ↓',
  cardsSortCreatedAsc: '創建日期 ↑',
  cardsSortUpdatedDesc: '更新日期 ↓',
  cardsSortUpdatedAsc: '更新日期 ↑',
  shortcutSeekPrev: '上一個字幕',
  shortcutSeekRepeat: '重複字幕',
  shortcutSeekNext: '下一個字幕',
  shortcutDelayBothDown: '減慢字幕速度',
  shortcutDelayBothUp: '加快字幕速度',
  shortcutDelayMainDown: '減慢字幕速度（主字幕）',
  shortcutDelayMainUp: '加快字幕速度（主字幕）',
  shortcutDelaySecondDown: '減慢字幕速度（副字幕）',
  shortcutDelaySecondUp: '加快字幕速度（副字幕）',
  shortcutToggleMain: '顯示 / 隱藏主字幕',
  shortcutToggleSecond: '顯示 / 隱藏副字幕',
  shortcutDualMain: '同時顯示原文與譯文（主字幕）',
  shortcutDualSecond: '同時顯示原文與譯文（副字幕）',
  shortcutCopy: '複製所選文字',
  shortcutReader: '字幕朗讀器',
  shortcutDictationHint: '提示',
  shortcutDictationPlayWord: '從目前單字播放',
  shortcutSpeakingRecord: '錄音 (長按)',
  shortcutSpeakingRecordToggle: '錄音 (單按切換)',
  shortcutSpeakingReplay: '重播錄音',
  shortcutMic: '麥克風監聽',
  railSeekPrev: '上一個字幕',
  railSeekRepeat: '重複字幕',
  railSeekNext: '下一個字幕',
  railPlay: '播放',
  railPause: '暫停',
  railDelayMain: '主字幕延遲',
  railDelaySecond: '副字幕延遲',
  railDelayDown: '字幕提早（−0.1s）',
  railDelayUp: '字幕延後（+0.1s）',
  railPosition: '調節字幕位置',
  railPositionSlider: '字幕位置',
  railFontSize: '字體大小',
  railFontSizeSlider: '字體大小',
  railCenter: '調節中線',
  railCenterSlider: '中線位置',
  railControls: '控制列',
  railPin: '釘選控制列',
  langPickerPopular: '常用語言',
  langPickerMore: '更多語言',
  langPickerNone: '不翻譯',
  langPickerCustom: '自訂代碼…',
  langPickerCustomCode: '語言代碼',
  translateTo: '翻譯成',
  trackSelectLabel: '字幕軌',
  trackSelectPlaceholder: '請選擇一個字幕選項。',
  trackHide: '隱藏主字幕',
  trackLoading: '載入中...',
  trackLoadFailed: '載入字幕失敗',
  memberTrackHint: '會員功能',
  trackSource: '來源',
  trackSourceUpload: '上傳',
  trackSourceDemo: '示範字幕',
  trackAdvancedShow: '顯示進階…',
  trackAdvancedHide: '隱藏進階',
  trackEmpty: '此影片沒有字幕軌 — 請到設定匯入字幕檔（.vtt / .srt / .json3）。',
  trackChooseFile: '上傳',
  trackUploadCta: '匯入字幕',
  trackAddFile: '匯入字幕',
  trackSlotMain: '主字幕',
  trackSlotSecond: '副字幕',
  trackSlotSecondAdvanced: '第二軌（進階）',
  trackTranslateMain: '主字幕',
  trackTranslateSecond: '副字幕',
  trackListing: '載入中...',
  settingsTabSubs: '字幕',
  settingsTabPractice: '練習',
  settingsTabLook: '外觀',
  settingsTabAdvanced: '其他',
  practiceHintWatch: '一般雙字幕。可在上方開啟「可選取」以複製文字。',
  practiceHintDictation: '聽寫你聽到的內容；每句結束會暫停，打完才進下一句。',
  practiceHintSpeaking: '朗讀每一句，再核對錄音。',
  practiceHintLearning: '點選單字查詢並存成卡片。',
  practiceEnd: '結束練習',
  translationStatusBusy: '生成中 (#)...',
  translationStatusFailed: '錯誤',
  translationQuota: '超過配額上限',
  translationFailed: '錯誤',
  translationMemberOnly: '會員功能',
  serviceLoading: '載入中...',
  serviceQueuing: '排隊中 (#) (@)...',
  serviceGenerating: '生成中 (#)...',
  serviceDownloading: '下載中...',
  serviceEnhanced: '斷句',
  serviceMemberOnly: '會員功能',
  serviceDismissUnknown: '發生錯誤，請再試一次',
  serviceDismissInfo: '無法取得此影片的字幕',
  serviceDismissLength: '影片過長，無法處理',
  serviceDismissLive: '不支援直播影片',
  serviceDismissSource: '請先產生或增強來源字幕',
  serviceDismissEnhance: '增強失敗，請再試一次',
  serviceDismissEnhanceTimeout: '增強逾時，請再試一次',
  serviceDismissUpstream: '伺服器發生錯誤，請再試一次',
  serviceDismissCancelled: '已取消',
  hoverRevealShow: '字幕懸停顯示',
  cardsSignInCta: '登入',
  more: '其他',
  learnSave: '儲存',
  learnSaved: '已儲存',
  learnPin: '釘選',
  learnUnpin: '取消釘選',
  learnMove: '移動',
  learnSpeak: '朗讀',
  learnMembersOnly: '會員專屬功能',
  recentWatches: '最近觀看',
  recentWatchOpen: '開啟',
  subtitleLoadStatus: '載入中...',
  subtitleLoadListing: '載入中...',
  subtitleLoadDownloading: '下載中...',
  practiceWaitingPlayer: '等待播放器就緒… 影片就緒後會出現練習控件。',
  trackLoadProgress: '進度',
  dictationPlaceholder: '輸入你聽到的內容…',
  dictationPlaceholderSpeaking: '朗讀後核對錄音…',
  dictationTapToType: '點擊開始打字',
  dictationTapToSpeak: '點擊開始口說',
  dictationTapToShadow: '點擊開始跟讀',
  dictationDone: '完成',
  stageOpenTracks: '開啟字幕',
  stageOpenSettings: '開啟設定',
  stagePickTranslateLang: '選擇翻譯語言以顯示雙語字幕。',
  stageRetryLoad: '重試',
  stageSignIn: '登入',
  stageDismiss: '關閉',
  stageBilingualSummary: '雙語 · {lang}',
  practiceOpen: '觀看',
  memberTrackLabel: '會員功能',
  exportSrt: '輸出字幕',
  exportSrtMain: '主字幕',
  exportSrtSecond: '副字幕',
  exportSrtDone: '下載',
  exportSrtNeedTrack: '請先選擇字幕軌。',
  importSrt: '匯入字幕',
  importSrtMain: '主字幕',
  importSrtSecond: '副字幕',
  importSrtUpload: '上傳',
  importSrtUploaded: '已上傳的字幕',
  settingsStyleCopy: '複製主字幕樣式',
  settingsStyleCopyFromSecond: '複製副字幕樣式',
  settingsStyleCopyFromMain: '複製主字幕樣式',
  settingsStyleResetTrack: '回到預設',
  settingsStyleSlotMain: '主',
  settingsStyleSlotSecond: '副',
  landingWebDiff: '與擴充功能相同的雙語 Tracks。字幕經安全代理 · 請用 Email 登入 · 非注入 youtube.com。',
  landingTagline: '手機上看 YouTube 雙語字幕。',
  landingUrlLabel: 'YouTube 連結',
  landingOpen: '開啟影片',
  landingUrlInvalid: '請輸入有效的 YouTube 網址或影片 ID。',
  landingTrySample: '試看範例影片',
  loginWebDiff: '請使用綁定會員的 Email 驗證碼登入，以解鎖會員功能。',
  loginEmailTitle: '使用驗證碼登入',
  loginEmailDesc: '請輸入您在 Patreon 註冊時使用的電子郵件，我們會寄送一次性驗證碼（請檢查垃圾郵件）。',
  loginEmailLabel: '電子郵件',
  loginSendCode: '寄送驗證碼',
  loginSending: '寄送中…',
  loginCodeLabel: '驗證碼',
  loginSubmit: '登入',
  loginSubmitting: '登入中…',
  loginOr: '或',
  loginPatreon: '使用 Patreon 登入',
  loginPatreonNote: '會在新分頁開啟 Patreon。若無法自動回寫會員狀態，請改用上方 Email 驗證。',
  loginLogout: '登出',
  memberStatusPrefix: '會員狀態:',
  memberStatusActive: '啟用中',
  memberStatusInactive: '未啟用',
  memberStatusSessionExpired: '登入已失效，請重新登入',
  memberStatusCheckFailed: '錯誤',
  memberStatusSignedIn: '已登入',
  loginMsgSignedIn: '已登入。',
  loginMsgInactive: '已登入 — 會員未啟用。',
  loginMsgSessionExpired: '已登入 — 工作階段已過期，請重新登入。',
  loginMsgEmailSent: '驗證碼已寄出，請檢查收件匣（含垃圾郵件）。',
  loginMsgInvalidCode: '驗證碼無效或已使用。',
  loginMsgNotSubscriber: '找不到訂閱（此 Email 未註冊）。',
  loginMsgQuotaExceeded: '已超過使用額度，請稍後再試。',
  loginMsgRateLimited: '請求過於頻繁，請約 30 秒後再試。',
  loginMsgEnterEmail: '請輸入電子郵件。',
  loginMsgNetworkError: '網路或伺服器錯誤。',
  settingsMembersSuffix: '（會員）',
  settingsDocs: '使用文檔',
  settingsDocsOpen: '使用文檔',
  settingsStylePreview: '預覽',
  settingsStylePreviewHint: '主＋副 · 調整時即時更新',
  settingsResetAll: '重設',
  cuePanelLock: '跟隨播放',
  cuePanelUnlock: '解除跟隨',
  cuePanelResize: '調整字幕列表大小',
  settingsSelectable: '讓字幕可被選取',
  settingsSubtitleOptimize: 'AI 斷句',
  settingsSubtitleOptimizeEnable: '啟用',
  settingsSubtitleOptimizeModel: '模型',
  settingsSubtitleOptimizeModelAuto: '自動',
  settingsSubtitleOptimizeModelSmall: 'Small',
  settingsSubtitleOptimizeModelLarge: 'Large',
  learnCopy: '複製所選文字',
  loginCallbackWorking: '正在完成 Patreon 登入…',
  loginCallbackOk: '已登入，返回中…',
  loginCallbackFail: '無法從此頁讀取登入資訊。請改用 Email 驗證，或在 Patreon 登記此 redirect URI。',
  loginCallbackContinue: '繼續',
  styleStudioTitle: '字幕樣式工作室',
  styleStudioOpen: '開啟樣式工作室',
  styleStudioApplied: '樣式已套用。',
  styleStudioApplyScope: '套用至',
  styleStudioScopeBoth: '兩者',
  styleStudioScopeMain: '主字幕',
  styleStudioScopeSecond: '副字幕',
  styleStudioCustoms: '我的樣式',
  styleStudioCustomsEmpty: '尚無自訂樣式 — 可儲存目前主軌外觀。',
  styleStudioCustomName: '樣式名稱',
  styleStudioSave: '儲存樣式',
  styleStudioDelete: '刪除',
  styleStudioGoogleFonts: 'Google 字型',
  styleStudioGoogleSearch: '搜尋字型',
  styleStudioGooglePick: '搜尋字型',
  styleStudioGoogleLoading: '載入中...',
  styleStudioGoogleClear: '清除 Google 字型',
  styleStudioGoogleCurrent: '目前',
  styleStudioGoogleNone: '此軌尚未套用 Google 字型（僅系統字型）。',
  styleStudioGoogleSubset: '語言',
  styleStudioGoogleSubsetAll: '全部',
  styleStudioGoogleNeedFilter: '請選擇語言子集或搜尋以列出字型。',
  styleStudioGoogleLoadMore: '載入更多',
  styleStudioLangBind: '依語言套用樣式',
  styleStudioLangBindHint: '當字幕語言符合下列綁定時，會自動在影片上套用對應的自訂樣式。',
  styleStudioLangBindNeedCustom: '請先儲存自訂樣式，再在此綁定語言。',
  styleStudioLangBindSelectCustom: '請先在上方選取自訂樣式以編輯語言綁定。',
  styleStudioLangSearch: '搜尋語言',
  styleStudioLangConflict: '已被「{name}」使用。',
  styleStudioLangBindEmpty: '尚無語言綁定。',
  styleStudioBindAdd: '綁定',
  styleStudioBindRemove: '移除',
};

const ZH_CN: Record<StringKey, string> = {
  appName: 'RikoSub',
  settings: '设置',
  settingsClose: '关闭',
  settingsPosition: '字幕位置',
  settingsStyleMain: '主字幕',
  settingsStyleSecond: '副字幕',
  settingsPresets: '预设样式',
  settingsLanguage: '介面语言',
  settingsSubY: '字幕位置',
  settingsSeparation: '字幕分离显示',
  settingsSpacing: '字幕间距',
  settingsMaxWidth: '最大宽度',
  settingsFontSize: '字体大小',
  settingsFontColor: '字体颜色',
  settingsFontWeight: '字体粗细',
  settingsStroke: '字体描边宽度',
  settingsOpacity: '不透明度',
  settingsDarkMode: '夜间模式',
  settingsEngine: '翻译引擎',
  settingsApplyPreset: '应用',
  tracks: '字幕轨',
  signIn: '登入',
  member: '会员',
  account: '帐号',
  back: '返回',
  settingsPractice: '练习',
  settingsPracticeMode: '模式',
  settingsPracticeWatch: '观看',
  settingsPracticeDictation: '听写',
  settingsPracticeSpeaking: '口语',
  settingsPracticeShadowing: '跟读',
  settingsPracticeLearning: '学习',
  settingsShadowingGrayPast: '已读变灰',
  settingsShadowingHideUpcoming: '提前隐藏',
  settingsShadowingAutoRemoveLineBreaks: '自动启用移除换行',
  settingsDictationSubtitle: '主要 / 次要',
  settingsDictationMain: '主要',
  settingsDictationSecond: '次要',
  settingsDictationFiltered: '过滤词',
  settingsDictationIgnoreBrackets: '忽略括号及其内容',
  settingsDictationTypingVolume: '按键音量',
  settingsDictationInputPosition: '输入栏位置',
  settingsDictationPositionTop: '顶部',
  settingsDictationPositionBottom: '底部',
  settingsSpeakingVolume: '播放音量',
  settingsFurigana: '假名注音',
  settingsFuriganaEnable: '启用',
  settingsFuriganaConvert: '转换为',
  settingsFuriganaRomaji: '罗马音',
  settingsReader: '字幕朗读器',
  settingsReaderEnable: '启用',
  settingsReaderVoice: '语音',
  settingsReaderVoiceDefault: '自动',
  settingsReaderRate: '语速',
  settingsReaderVolume: '音量',
  settingsFontFamily: '字體',
  settingsFontGoogleFamilies: '谷歌字體（Font families）',
  settingsFontGoogleCss: '谷歌字體（CSS properties）',
  settingsFontPreset: '字體',
  settingsShadow: '阴影',
  settingsShadowColor: '阴影颜色',
  settingsBackground: '背景颜色',
  settingsBackgroundOpacity: '背景透明度',
  settingsLetterSpacing: '字距',
  settingsLineHeight: '行高',
  settingsPadding: '内边距',
  settingsBoxShadow: '底框阴影',
  settingsStrokeColor: '字体描边颜色',
  settingsShadowNone: '无',
  settingsShadowRaised: '浮凸',
  settingsShadowDepressed: '內凹',
  settingsShadowOutline: '外框',
  settingsShadowShadow: '阴影',
  settingsBoxShadowNone: '无',
  settingsBoxShadowSoft: '柔和',
  settingsBoxShadowMedium: '中等',
  settingsFontPresetNetflix: 'Netflix Sans',
  settingsFontPresetArial: 'Arial',
  settingsFontPresetVerdana: 'Verdana',
  settingsFontPresetTahoma: 'Tahoma',
  settingsFontPresetTrebuchet: 'Trebuchet MS',
  settingsFontPresetTimes: 'Times New Roman',
  settingsFontPresetGeorgia: 'Georgia',
  settingsFontPresetGaramond: 'Garamond',
  settingsFontPresetCourier: 'Courier New',
  settingsFontPresetBrush: 'Brush Script MT',
  settingsPreprocess: '字幕预处理',
  settingsPreprocess1: '移除换行',
  settingsPreprocess2: '移除括号内的文字',
  settingsPreprocess3: '合并时间相同的相邻字幕',
  settingsEnableShortcuts: '快捷键',
  settingsHoverToReveal: '字幕悬停显示',
  settingsSubtitleList: '字幕列表',
  settingsDragHandle: '字幕位置',
  cuePanelTitle: '字幕列表',
  cuePanelSlot: '轨道',
  cuePanelMain: '主要',
  cuePanelSecond: '次要',
  cuePanelEmpty: '请选择一个字幕选项。',
  cueList: '字幕列表',
  settingsLearningTarget: '目标语言',
  learnTargetNone: '-',
  learnTargetNotSet: '请先在设定 → 练习 → 学习模式中选择目标语言。',
  settingsLearningDefaultPrompt: '默认提示词',
  settingsLearningCardsLink: '链接',
  settingsMainSubY: '字幕位置（主字幕）',
  settingsSecondSubY: '字幕位置（副字幕）',
  learnPromptMeaning: '简要说明',
  learnPromptExamples: '五个例子',
  learnPromptDictionary: '词典',
  learnTtsRate: '语速',
  learnTtsRateXslow: '极慢',
  learnTtsRateSlow: '慢',
  learnTtsRateMedium: '中等',
  learnUnsave: '移除卡片',
  learnLoading: '加载中...',
  learnLoadingAi: '加载中...',
  learnQuota: '已达到配额限制',
  learnTtsFailed: '失败',
  learnSaveFailed: '错误',
  learnSaving: '储存中…',
  learnMembersSignIn: '会员专享功能',
  learnMembersAi: '会员专享功能',
  speakRecord: '录音',
  speakStop: '停止',
  speakReplay: '重播录音',
  speakMic: '监听',
  speakErrorSecure: '麦克风需要 HTTPS。请用安全连线（或 localhost）开启此页。',
  speakErrorPermission: '无法使用麦克风（权限被拒）。',
  speakErrorUnsupported: '此浏览器不支援录音。',
  speakErrorUnknown: '无法存取麦克风。',
  practiceNavPrev: '上一句',
  practiceNavReplay: '重播',
  practiceNavNext: '下一句',
  cardsTitle: '已保存卡片',
  cardsDeck: '分类',
  cardsSort: '排序',
  cardsUncategorized: '未分类',
  cardsDeckName: '分类名',
  cardsCreateDeck: '建立分类',
  cardsRemoveDeck: '移除分类',
  cardsDeleteCard: '删除',
  cardsEditCard: '更新卡片',
  cardsExportCsv: '导出卡片 (CSV)',
  cardsSave: '提交',
  cardsClose: '关闭',
  cardsFailed: '错误',
  cardsFieldFront: '正面',
  cardsFieldFrontTrans: '正面翻译',
  cardsFieldRefSent: '例句',
  cardsFieldRefTrans: '例句翻译',
  cardsFieldFrontDesc: '正面注记',
  cardsFieldBackDesc: '背面注记',
  cardsEmpty: '此分类尚无卡片。',
  cardsLoading: '加载中...',
  cardsLoginRequired: '请先登录会员以查看已保存的卡片。',
  cardsDuplicate: '已有相同的分类',
  cardsRemoveDeckConfirm: '确定移除此分类？其中的卡片也会一并删除。',
  cardsRefresh: '重新整理',
  cardsSortCreatedDesc: '创建日期 ↓',
  cardsSortCreatedAsc: '创建日期 ↑',
  cardsSortUpdatedDesc: '更新日期 ↓',
  cardsSortUpdatedAsc: '更新日期 ↑',
  shortcutSeekPrev: '上一个字幕',
  shortcutSeekRepeat: '重复字幕',
  shortcutSeekNext: '下一个字幕',
  shortcutDelayBothDown: '减慢字幕速度',
  shortcutDelayBothUp: '加快字幕速度',
  shortcutDelayMainDown: '减慢字幕速度（主字幕）',
  shortcutDelayMainUp: '加快字幕速度（主字幕）',
  shortcutDelaySecondDown: '减慢字幕速度（副字幕）',
  shortcutDelaySecondUp: '加快字幕速度（副字幕）',
  shortcutToggleMain: '显示 / 隐藏主字幕',
  shortcutToggleSecond: '显示 / 隐藏副字幕',
  shortcutDualMain: '同时显示原文与译文（主字幕）',
  shortcutDualSecond: '同时显示原文与译文（副字幕）',
  shortcutCopy: '复制所选文本',
  shortcutReader: '字幕朗读器',
  shortcutDictationHint: '提示',
  shortcutDictationPlayWord: '从当前单词播放',
  shortcutSpeakingRecord: '录音（长按）',
  shortcutSpeakingRecordToggle: '录音（单击切换）',
  shortcutSpeakingReplay: '重播录音',
  shortcutMic: '麦克风监听',
  railSeekPrev: '上一个字幕',
  railSeekRepeat: '重复字幕',
  railSeekNext: '下一个字幕',
  railPlay: '播放',
  railPause: '暂停',
  railDelayMain: '主字幕延迟',
  railDelaySecond: '副字幕延迟',
  railDelayDown: '字幕提早（−0.1s）',
  railDelayUp: '字幕延后（+0.1s）',
  railPosition: '调节字幕位置',
  railPositionSlider: '字幕位置',
  railFontSize: '字体大小',
  railFontSizeSlider: '字体大小',
  railCenter: '调节中线',
  railCenterSlider: '中线位置',
  railControls: '控制列',
  railPin: '钉选控制列',
  langPickerPopular: '常用语言',
  langPickerMore: '更多语言',
  langPickerNone: '不翻译',
  langPickerCustom: '自订代码…',
  langPickerCustomCode: '语言代码',
  translateTo: '翻译成',
  trackSelectLabel: '字幕轨',
  trackSelectPlaceholder: '请选择一个字幕选项。',
  trackHide: '隐藏主字幕',
  trackLoading: '载入中...',
  trackLoadFailed: '载入字幕失败',
  memberTrackHint: '会员功能',
  trackSource: '来源',
  trackSourceUpload: '上传',
  trackSourceDemo: '示范字幕',
  trackAdvancedShow: '显示进阶…',
  trackAdvancedHide: '隐藏进阶',
  trackEmpty: '此影片没有字幕轨 — 请到设定汇入字幕档（.vtt / .srt / .json3）。',
  trackChooseFile: '上传',
  trackUploadCta: '导入字幕',
  trackAddFile: '导入字幕',
  trackSlotMain: '主字幕',
  trackSlotSecond: '副字幕',
  trackSlotSecondAdvanced: '第二轨（进阶）',
  trackTranslateMain: '主字幕',
  trackTranslateSecond: '副字幕',
  trackListing: '载入中...',
  settingsTabSubs: '字幕',
  settingsTabPractice: '练习',
  settingsTabLook: '外观',
  settingsTabAdvanced: '其他',
  practiceHintWatch: '普通双字幕。可在上方开启“可选中”以复制文字。',
  practiceHintDictation: '听写你听到的内容；每句结束会暂停，打完才进下一句。',
  practiceHintSpeaking: '朗读每一句，再核对录音。',
  practiceHintLearning: '点选单字查询并存成卡片。',
  practiceEnd: '结束练习',
  translationStatusBusy: '生成中 (#)...',
  translationStatusFailed: '错误',
  translationQuota: '超过配额上限d',
  translationFailed: '错误',
  translationMemberOnly: '会员功能',
  serviceLoading: '载入中...',
  serviceQueuing: '排队中 (#) (@)...',
  serviceGenerating: '生成中 (#)...',
  serviceDownloading: '下载中...',
  serviceEnhanced: '断句',
  serviceMemberOnly: '会员功能',
  serviceDismissUnknown: '发生错误，请再试一次',
  serviceDismissInfo: '无法取得此影片的字幕',
  serviceDismissLength: '影片过长，无法处理',
  serviceDismissLive: '不支持直播影片',
  serviceDismissSource: '请先生成或增强来源字幕',
  serviceDismissEnhance: '增强失败，请再试一次',
  serviceDismissEnhanceTimeout: '增强超时，请再试一次',
  serviceDismissUpstream: '服务器发生错误，请再试一次',
  serviceDismissCancelled: '已取消',
  hoverRevealShow: '字幕悬停显示',
  cardsSignInCta: '登入',
  more: '其他',
  learnSave: '储存',
  learnSaved: '已储存',
  learnPin: '钉选',
  learnUnpin: '取消钉选',
  learnMove: '移动',
  learnSpeak: '朗读',
  learnMembersOnly: '会员专享功能',
  recentWatches: '最近观看',
  recentWatchOpen: '开启',
  subtitleLoadStatus: '载入中...',
  subtitleLoadListing: '载入中...',
  subtitleLoadDownloading: '下载中...',
  practiceWaitingPlayer: '等待播放器就绪… 影片就绪后会出现练习控件。',
  trackLoadProgress: '进度',
  dictationPlaceholder: '输入你听到的内容…',
  dictationPlaceholderSpeaking: '朗读后核对录音…',
  dictationTapToType: '点击开始打字',
  dictationTapToSpeak: '点击开始口说',
  dictationTapToShadow: '点击开始跟读',
  dictationDone: '完成',
  stageOpenTracks: '开启字幕',
  stageOpenSettings: '开启设定',
  stagePickTranslateLang: '选择翻译语言以显示双语字幕。',
  stageRetryLoad: '重试',
  stageSignIn: '登入',
  stageDismiss: '关闭',
  stageBilingualSummary: '双语 · {lang}',
  practiceOpen: '观看',
  memberTrackLabel: '会员功能',
  exportSrt: '导出字幕',
  exportSrtMain: '主字幕',
  exportSrtSecond: '副字幕',
  exportSrtDone: '下载',
  exportSrtNeedTrack: '请先选择字幕轨。',
  importSrt: '导入字幕',
  importSrtMain: '主字幕',
  importSrtSecond: '副字幕',
  importSrtUpload: '上传',
  importSrtUploaded: '已上传的字幕',
  settingsStyleCopy: '复制主字幕样式',
  settingsStyleCopyFromSecond: '复制副字幕样式',
  settingsStyleCopyFromMain: '复制主字幕样式',
  settingsStyleResetTrack: '恢复默认',
  settingsStyleSlotMain: '主',
  settingsStyleSlotSecond: '副',
  landingWebDiff: '与扩充功能相同的双语 Tracks。字幕经安全代理 · 请用 Email 登入 · 非注入 youtube.com。',
  landingTagline: '手机上看 YouTube 双语字幕。',
  landingUrlLabel: 'YouTube 连结',
  landingOpen: '开启影片',
  landingUrlInvalid: '请输入有效的 YouTube 网址或影片 ID。',
  landingTrySample: '试看范例影片',
  loginWebDiff: '请使用绑定会员的 Email 验证码登入，以解锁会员功能。',
  loginEmailTitle: '使用验证码登录',
  loginEmailDesc: '请输入您在 Patreon 注册时使用的电子邮件，我们会寄送一次性验证码（请检查垃圾邮件）。',
  loginEmailLabel: '电子邮件',
  loginSendCode: '发送验证码',
  loginSending: '发送中…',
  loginCodeLabel: '验证码',
  loginSubmit: '登录',
  loginSubmitting: '登录中…',
  loginOr: '或',
  loginPatreon: '使用 Patreon 登录',
  loginPatreonNote: '会在新分页开启 Patreon。若无法自动回写会员状态，请改用上方 Email 验证。',
  loginLogout: '登出',
  memberStatusPrefix: '会员状态:',
  memberStatusActive: '启用中',
  memberStatusInactive: '未启用',
  memberStatusSessionExpired: '登录已失效，请重新登录',
  memberStatusCheckFailed: '错误',
  memberStatusSignedIn: '已登入',
  loginMsgSignedIn: '已登入。',
  loginMsgInactive: '已登入 — 会员未启用。',
  loginMsgSessionExpired: '已登入 — 工作阶段已过期，请重新登入。',
  loginMsgEmailSent: '验证码已寄出，请检查收件匣（含垃圾邮件）。',
  loginMsgInvalidCode: '验证码无效或已使用。',
  loginMsgNotSubscriber: '找不到订阅（此 Email 未注册）。',
  loginMsgQuotaExceeded: '已超过使用额度，请稍后再试。',
  loginMsgRateLimited: '请求过于频繁，请约 30 秒后再试。',
  loginMsgEnterEmail: '请输入电子邮件。',
  loginMsgNetworkError: '网路或伺服器错误。',
  settingsMembersSuffix: '（会员）',
  settingsDocs: '使用文档',
  settingsDocsOpen: '使用文档',
  settingsStylePreview: '预览',
  settingsStylePreviewHint: '主＋副 · 调整时即时更新',
  settingsResetAll: '重置',
  cuePanelLock: '跟随播放',
  cuePanelUnlock: '解除跟随',
  cuePanelResize: '调整字幕列表大小',
  settingsSelectable: '让字幕可被选取',
  settingsSubtitleOptimize: 'AI 断句',
  settingsSubtitleOptimizeEnable: '启用',
  settingsSubtitleOptimizeModel: '模型',
  settingsSubtitleOptimizeModelAuto: '自动',
  settingsSubtitleOptimizeModelSmall: 'Small',
  settingsSubtitleOptimizeModelLarge: 'Large',
  learnCopy: '复制所选文本',
  loginCallbackWorking: '正在完成 Patreon 登入…',
  loginCallbackOk: '已登入，返回中…',
  loginCallbackFail: '无法从此页读取登入资讯。请改用 Email 验证，或在 Patreon 登记此 redirect URI。',
  loginCallbackContinue: '继续',
  styleStudioTitle: '字幕样式工作室',
  styleStudioOpen: '打开样式工作室',
  styleStudioApplied: '样式已应用。',
  styleStudioApplyScope: '应用到',
  styleStudioScopeBoth: '两者',
  styleStudioScopeMain: '主字幕',
  styleStudioScopeSecond: '副字幕',
  styleStudioCustoms: '我的样式',
  styleStudioCustomsEmpty: '尚无自订样式 — 可储存目前主轨外观。',
  styleStudioCustomName: '样式名称',
  styleStudioSave: '保存样式',
  styleStudioDelete: '删除',
  styleStudioGoogleFonts: 'Google 字体',
  styleStudioGoogleSearch: '搜索字体',
  styleStudioGooglePick: '搜索字体',
  styleStudioGoogleLoading: '载入中...',
  styleStudioGoogleClear: '清除 Google 字型',
  styleStudioGoogleCurrent: '目前',
  styleStudioGoogleNone: '此轨尚未套用 Google 字型（仅系统字型）。',
  styleStudioGoogleSubset: '语言',
  styleStudioGoogleSubsetAll: '全部',
  styleStudioGoogleNeedFilter: '请选择语言子集或搜索以列出字体。',
  styleStudioGoogleLoadMore: '加载更多',
  styleStudioLangBind: '按语言套用样式',
  styleStudioLangBindHint: '当字幕语言符合下列绑定时，会自动在视频上套用对应的自定义样式。',
  styleStudioLangBindNeedCustom: '请先储存自订样式，再在此绑定语言。',
  styleStudioLangBindSelectCustom: '请先在上方选取自订样式以编辑语言绑定。',
  styleStudioLangSearch: '搜索语言',
  styleStudioLangConflict: '已被“{name}”使用。',
  styleStudioLangBindEmpty: '尚无语言绑定。',
  styleStudioBindAdd: '绑定',
  styleStudioBindRemove: '移除',
};

const JA: Record<StringKey, string> = {
  appName: 'RikoSub',
  settings: '設定',
  settingsClose: '閉じる',
  settingsPosition: '字幕位置',
  settingsStyleMain: 'メイン字幕',
  settingsStyleSecond: 'サブ字幕',
  settingsPresets: 'プリセット',
  settingsLanguage: 'UI言語',
  settingsSubY: '字幕位置',
  settingsSeparation: '字幕の分離表示',
  settingsSpacing: '字幕間隔',
  settingsMaxWidth: '最大幅',
  settingsFontSize: 'フォントサイズ',
  settingsFontColor: 'フォント色',
  settingsFontWeight: 'フォントの太さ',
  settingsStroke: 'フォントの縁取りの太さ',
  settingsOpacity: '不透明度',
  settingsDarkMode: 'ダークモード',
  settingsEngine: '翻訳エンジン',
  settingsApplyPreset: '適用',
  tracks: '字幕トラック',
  signIn: 'ログイン',
  member: 'メンバー',
  account: 'アカウント',
  back: '戻る',
  settingsPractice: '練習',
  settingsPracticeMode: 'モード',
  settingsPracticeWatch: '視聴',
  settingsPracticeDictation: 'ディクテーション',
  settingsPracticeSpeaking: 'スピーキング',
  settingsPracticeShadowing: 'シャドーイング',
  settingsPracticeLearning: '学習',
  settingsShadowingGrayPast: '過去をグレー表示',
  settingsShadowingHideUpcoming: '先の行を隠す',
  settingsShadowingAutoRemoveLineBreaks: '改行を自動削除',
  settingsDictationSubtitle: 'メイン / サブ',
  settingsDictationMain: 'メイン',
  settingsDictationSecond: 'サブ',
  settingsDictationFiltered: '除外ワード',
  settingsDictationIgnoreBrackets: '括弧内のテキストを除外',
  settingsDictationTypingVolume: 'キー操作音量',
  settingsDictationInputPosition: '入力欄の位置',
  settingsDictationPositionTop: '上部',
  settingsDictationPositionBottom: '下部',
  settingsSpeakingVolume: '再生音量',
  settingsFurigana: 'ふりがな',
  settingsFuriganaEnable: '有効',
  settingsFuriganaConvert: '変換先',
  settingsFuriganaRomaji: 'ローマ字',
  settingsReader: '字幕リーダー',
  settingsReaderEnable: '有効',
  settingsReaderVoice: '音声',
  settingsReaderVoiceDefault: '自動',
  settingsReaderRate: '速度',
  settingsReaderVolume: '音量',
  settingsFontFamily: 'フォントファミリー',
  settingsFontGoogleFamilies: 'Google フォント（Font families）',
  settingsFontGoogleCss: 'Google フォント（CSS properties）',
  settingsFontPreset: 'フォントファミリー',
  settingsShadow: '影',
  settingsShadowColor: '影の色',
  settingsBackground: '背景色',
  settingsBackgroundOpacity: '背景透明度',
  settingsLetterSpacing: '字間',
  settingsLineHeight: '行間',
  settingsPadding: '余白',
  settingsBoxShadow: 'ボックス影',
  settingsStrokeColor: '文字の縁取り色',
  settingsShadowNone: 'なし',
  settingsShadowRaised: '浮き出し',
  settingsShadowDepressed: '押し込み',
  settingsShadowOutline: '輪郭',
  settingsShadowShadow: 'シャドウ',
  settingsBoxShadowNone: 'なし',
  settingsBoxShadowSoft: 'ソフト',
  settingsBoxShadowMedium: 'ミディアム',
  settingsFontPresetNetflix: 'Netflix Sans',
  settingsFontPresetArial: 'Arial',
  settingsFontPresetVerdana: 'Verdana',
  settingsFontPresetTahoma: 'Tahoma',
  settingsFontPresetTrebuchet: 'Trebuchet MS',
  settingsFontPresetTimes: 'Times New Roman',
  settingsFontPresetGeorgia: 'Georgia',
  settingsFontPresetGaramond: 'Garamond',
  settingsFontPresetCourier: 'Courier New',
  settingsFontPresetBrush: 'Brush Script MT',
  settingsPreprocess: '字幕の前処理',
  settingsPreprocess1: '改行を削除',
  settingsPreprocess2: '括弧内のテキストを削除',
  settingsPreprocess3: '同じタイミングの隣接字幕を結合',
  settingsEnableShortcuts: 'ショートカット',
  settingsHoverToReveal: '字幕をホバーで表示',
  settingsSubtitleList: '字幕列表',
  settingsDragHandle: '字幕位置',
  cuePanelTitle: '字幕列表',
  cuePanelSlot: 'スロット',
  cuePanelMain: 'メイン',
  cuePanelSecond: 'サブ',
  cuePanelEmpty: '字幕オプションを選択してください。',
  cueList: '字幕列表',
  settingsLearningTarget: 'ターゲット言語',
  learnTargetNone: '-',
  learnTargetNotSet: '設定 → 練習 → 学習 で目標言語を選んでください。',
  settingsLearningDefaultPrompt: 'デフォルトのプロンプト',
  settingsLearningCardsLink: 'リンク',
  settingsMainSubY: '字幕位置（メイン字幕）',
  settingsSecondSubY: '字幕位置（サブ字幕）',
  learnPromptMeaning: '簡単な説明',
  learnPromptExamples: '5つの例文',
  learnPromptDictionary: '辞書',
  learnTtsRate: '速度',
  learnTtsRateXslow: 'とても遅い',
  learnTtsRateSlow: '遅い',
  learnTtsRateMedium: '普通',
  learnUnsave: 'カードを削除',
  learnLoading: '読み込み中...',
  learnLoadingAi: '読み込み中...',
  learnQuota: '上限に達しました',
  learnTtsFailed: '失敗しました',
  learnSaveFailed: 'エラー',
  learnSaving: '保存中…',
  learnMembersSignIn: 'メンバー限定機能',
  learnMembersAi: 'メンバー限定機能',
  speakRecord: '録音',
  speakStop: '停止',
  speakReplay: '録音を再生',
  speakMic: 'マイク',
  speakErrorSecure: 'マイクには HTTPS が必要です。セキュアな接続（または localhost）で開いてください。',
  speakErrorPermission: 'マイクの許可が拒否されました。',
  speakErrorUnsupported: 'このブラウザでは録音に対応していません。',
  speakErrorUnknown: 'マイクにアクセスできませんでした。',
  practiceNavPrev: '前へ',
  practiceNavReplay: 'リプレイ',
  practiceNavNext: '次へ',
  cardsTitle: '保存したカード',
  cardsDeck: 'デッキ',
  cardsSort: '並べ替え',
  cardsUncategorized: '未分類',
  cardsDeckName: 'カテゴリー名',
  cardsCreateDeck: 'カテゴリーを作成',
  cardsRemoveDeck: 'カテゴリーを削除',
  cardsDeleteCard: '削除',
  cardsEditCard: 'カードを更新',
  cardsExportCsv: 'カードを書き出す (CSV)',
  cardsSave: '送信',
  cardsClose: '閉じる',
  cardsFailed: 'エラー',
  cardsFieldFront: '表面',
  cardsFieldFrontTrans: '表面の訳',
  cardsFieldRefSent: '参照文',
  cardsFieldRefTrans: '参照文の訳',
  cardsFieldFrontDesc: '表面メモ',
  cardsFieldBackDesc: '裏面メモ',
  cardsEmpty: 'このデッキにカードはありません。',
  cardsLoading: '読み込み中...',
  cardsLoginRequired: '保存したカードを表示するには、会員としてログインしてください。',
  cardsDuplicate: '同じデッキが既にあります',
  cardsRemoveDeckConfirm: 'このデッキを削除しますか？中のカードも削除されます。',
  cardsRefresh: '更新',
  cardsSortCreatedDesc: '作成日 ↓',
  cardsSortCreatedAsc: '作成日 ↑',
  cardsSortUpdatedDesc: '更新日 ↓',
  cardsSortUpdatedAsc: '更新日 ↑',
  shortcutSeekPrev: '前の字幕',
  shortcutSeekRepeat: '字幕を繰り返す',
  shortcutSeekNext: '次の字幕',
  shortcutDelayBothDown: '字幕速度を遅くする',
  shortcutDelayBothUp: '字幕速度を速くする',
  shortcutDelayMainDown: '字幕速度を遅くする（メイン字幕）',
  shortcutDelayMainUp: '字幕速度を速くす（メイン字幕）',
  shortcutDelaySecondDown: '字幕速度を遅くする（サブ字幕）',
  shortcutDelaySecondUp: '字幕速度を速くす（サブ字幕）',
  shortcutToggleMain: 'メイン字幕の表示/非表示',
  shortcutToggleSecond: 'サブ字幕の表示/非表示',
  shortcutDualMain: '原文と翻訳の同時表示（メイン字幕）',
  shortcutDualSecond: '原文と翻訳の同時表示（サブ字幕）',
  shortcutCopy: '選択したテキストをコピー',
  shortcutReader: '字幕リーダー',
  shortcutDictationHint: 'ヒント',
  shortcutDictationPlayWord: '現在の単語から再生',
  shortcutSpeakingRecord: '録音 (長押し）',
  shortcutSpeakingRecordToggle: '録音 (トグル)',
  shortcutSpeakingReplay: '録音を再生する',
  shortcutMic: 'マイクモニター',
  railSeekPrev: '前の字幕',
  railSeekRepeat: '字幕を繰り返し',
  railSeekNext: '次の字幕',
  railPlay: '再生',
  railPause: '一時停止',
  railDelayMain: '主字幕の遅延',
  railDelaySecond: '副字幕の遅延',
  railDelayDown: '字幕を早める（−0.1秒）',
  railDelayUp: '字幕を遅らせる（+0.1秒）',
  railPosition: '字幕位置',
  railPositionSlider: '字幕位置',
  railFontSize: '文字サイズ',
  railFontSizeSlider: '文字サイズ',
  railCenter: '中央線',
  railCenterSlider: '中央線',
  railControls: 'コントロール',
  railPin: 'コントロールを固定',
  langPickerPopular: 'よく使う言語',
  langPickerMore: 'その他の言語',
  langPickerNone: '翻訳なし',
  langPickerCustom: 'カスタムコード…',
  langPickerCustomCode: '言語コード',
  translateTo: '翻訳先',
  trackSelectLabel: 'トラック',
  trackSelectPlaceholder: '字幕オプションを選択してください。',
  trackHide: 'メイン字幕を非表示',
  trackLoading: 'ロード中...',
  trackLoadFailed: 'トラックの読み込みに失敗しました',
  memberTrackHint: '会員機能',
  trackSource: 'ソース',
  trackSourceUpload: 'アップロード',
  trackSourceDemo: 'デモ用フィクスチャ',
  trackAdvancedShow: '詳細を表示…',
  trackAdvancedHide: '詳細を隠す',
  trackEmpty: 'この動画に字幕トラックがありません — 設定からファイルをインポートしてください（.vtt / .srt / .json3）。',
  trackChooseFile: 'アップロード',
  trackUploadCta: '字幕をインポート',
  trackAddFile: '字幕をインポート',
  trackSlotMain: 'メイン字幕',
  trackSlotSecond: 'セカンダリ字幕',
  trackSlotSecondAdvanced: '副トラック（詳細）',
  trackTranslateMain: 'メイン字幕',
  trackTranslateSecond: 'セカンダリ字幕',
  trackListing: 'ロード中...',
  settingsTabSubs: '字幕',
  settingsTabPractice: '練習',
  settingsTabLook: '見た目',
  settingsTabAdvanced: 'その他',
  practiceHintWatch: '通常の二か国語字幕。上の「選択可能」でテキストをコピーできます。',
  practiceHintDictation: '聞こえた内容を入力します。各字幕の終わりで再生が一時停止し、入力完了まで待ちます。',
  practiceHintSpeaking: '各行を声に出して読み、録音を確認します。',
  practiceHintLearning: '単語を選んで調べ、カードを保存します。',
  practiceEnd: '練習を終了',
  translationStatusBusy: '生成中 (#)...',
  translationStatusFailed: 'エラー',
  translationQuota: '利用上限に達しました',
  translationFailed: 'エラー',
  translationMemberOnly: '会員機能',
  serviceLoading: 'ロード中...',
  serviceQueuing: 'キュー待ち (#) (@)...',
  serviceGenerating: '生成中 (#)...',
  serviceDownloading: 'ダウンロード中...',
  serviceEnhanced: '字幕分割',
  serviceMemberOnly: '会員機能',
  serviceDismissUnknown: 'エラーが発生しました。もう一度お試しください',
  serviceDismissInfo: 'この動画の字幕を取得できませんでした',
  serviceDismissLength: '動画が長すぎます',
  serviceDismissLive: 'ライブ配信には対応していません',
  serviceDismissSource: '先に元の字幕を生成または強化してください',
  serviceDismissEnhance: '強化に失敗しました。もう一度お試しください',
  serviceDismissEnhanceTimeout: '強化がタイムアウトしました。もう一度お試しください',
  serviceDismissUpstream: 'サーバーでエラーが発生しました。もう一度お試しください',
  serviceDismissCancelled: 'キャンセルされました',
  hoverRevealShow: '字幕をホバーで表示',
  cardsSignInCta: 'ログイン',
  more: 'その他',
  learnSave: '保存',
  learnSaved: '保存済み',
  learnPin: '固定',
  learnUnpin: '固定解除',
  learnMove: '移動',
  learnSpeak: '読み上げ',
  learnMembersOnly: 'メンバー限定機能',
  recentWatches: '最近',
  recentWatchOpen: '開く',
  subtitleLoadStatus: 'ロード中...',
  subtitleLoadListing: 'ロード中...',
  subtitleLoadDownloading: 'ダウンロード中...',
  practiceWaitingPlayer: 'プレーヤー待機中… 動画の準備が整うと練習コントロールが表示されます。',
  trackLoadProgress: '進行状況',
  dictationPlaceholder: '聞こえた内容を入力…',
  dictationPlaceholderSpeaking: '話してから録音を確認…',
  dictationTapToType: 'タップして入力開始',
  dictationTapToSpeak: 'タップして発話開始',
  dictationTapToShadow: 'タップしてシャドーイング開始',
  dictationDone: '完了',
  stageOpenTracks: 'トラックを開く',
  stageOpenSettings: '設定を開く',
  stagePickTranslateLang: '二か国語字幕の翻訳言語を選んでください。',
  stageRetryLoad: '再試行',
  stageSignIn: 'サインイン',
  stageDismiss: '閉じる',
  stageBilingualSummary: '二か国語 · {lang}',
  practiceOpen: '視聴',
  memberTrackLabel: '会員機能',
  exportSrt: '字幕をエクスポート',
  exportSrtMain: 'メイン字幕',
  exportSrtSecond: 'サブ字幕',
  exportSrtDone: 'ダウンロード',
  exportSrtNeedTrack: '先に字幕トラックを選択してください。',
  importSrt: '字幕をインポート',
  importSrtMain: 'メイン字幕',
  importSrtSecond: 'サブ字幕',
  importSrtUpload: 'アップロード',
  importSrtUploaded: 'アップロードされた字幕',
  settingsStyleCopy: '主字幕スタイルをコピー',
  settingsStyleCopyFromSecond: '副字幕スタイルをコピー',
  settingsStyleCopyFromMain: '主字幕スタイルをコピー',
  settingsStyleResetTrack: 'デフォルトに戻す',
  settingsStyleSlotMain: '主',
  settingsStyleSlotSecond: '副',
  landingWebDiff: '拡張機能と同じ二か国語トラック。安全なプロキシ経由の字幕 · メールでサインイン · youtube.com には注入しません。',
  landingTagline: 'モバイル向け YouTube 二か国語字幕。',
  landingUrlLabel: 'YouTube リンク',
  landingOpen: '動画を開く',
  landingUrlInvalid: '有効な YouTube URL または動画 ID を入力してください。',
  landingTrySample: 'サンプル動画を試す',
  loginWebDiff: 'メンバー機能の解除には、メンバーシップに紐づくメールでサインインしてください。',
  loginEmailTitle: 'Login with verification code',
  loginEmailDesc:
    'Enter the email used for your Patreon membership. We will send a one-time code (check spam).',
  loginEmailLabel: 'Email address',
  loginSendCode: 'Send code',
  loginSending: 'Sending…',
  loginCodeLabel: 'Verification code',
  loginSubmit: 'Login',
  loginSubmitting: 'Logging in…',
  loginOr: 'or',
  loginPatreon: 'Patreonでログイン',
  loginPatreonNote: 'Patreon を新しいタブで開きます。メンバーシップが戻らない場合は、上のメール認証を使ってください。',
  loginLogout: 'ログアウト',
  memberStatusPrefix: '会員ステータス：',
  memberStatusActive: '有効',
  memberStatusInactive: '無効',
  memberStatusSessionExpired: 'セッションの有効期限が切れました。再度ログインしてください',
  memberStatusCheckFailed: 'エラー',
  memberStatusSignedIn: 'サインイン済み',
  loginMsgSignedIn: 'サインインしました。',
  loginMsgInactive: 'サインイン済み — メンバーシップ無効。',
  loginMsgSessionExpired: 'サインイン済み — セッション期限切れ。再度サインインしてください。',
  loginMsgEmailSent: 'メールを送信しました。受信箱（迷惑メールも）を確認してください。',
  loginMsgInvalidCode: '無効または使用済みのコードです。',
  loginMsgNotSubscriber: '購読者ではありません（未登録のメール）。',
  loginMsgQuotaExceeded: '利用上限に達しました。後でもう一度お試しください。',
  loginMsgRateLimited: 'リクエストが多すぎます。約30秒待ってください。',
  loginMsgEnterEmail: 'メールアドレスを入力してください。',
  loginMsgNetworkError: 'ネットワークまたはサーバーエラー。',
  settingsMembersSuffix: '（メンバー）',
  settingsDocs: 'ドキュメント',
  settingsDocsOpen: 'ドキュメント',
  settingsStylePreview: 'プレビュー',
  settingsStylePreviewHint: '主 + 副 · 編集に合わせて更新',
  settingsResetAll: 'リセット',
  cuePanelLock: '再生に追従',
  cuePanelUnlock: 'スクロール解除',
  cuePanelResize: '字幕リストのサイズ変更',
  settingsSelectable: '字幕を選択可能にする',
  settingsSubtitleOptimize: 'AI字幕分割',
  settingsSubtitleOptimizeEnable: '有効',
  settingsSubtitleOptimizeModel: 'モデル',
  settingsSubtitleOptimizeModelAuto: '自動',
  settingsSubtitleOptimizeModelSmall: 'Small',
  settingsSubtitleOptimizeModelLarge: 'Large',
  learnCopy: '選択したテキストをコピー',
  loginCallbackWorking: 'Patreon サインインを完了中…',
  loginCallbackOk: 'サインインしました。戻ります…',
  loginCallbackFail: 'このページからログイン情報を取得できませんでした。メール認証を使うか、このリダイレクト URI を Patreon に登録してください。',
  loginCallbackContinue: '続ける',
  styleStudioTitle: '字幕スタイルスタジオ',
  styleStudioOpen: 'スタイルスタジオを開く',
  styleStudioApplied: 'スタイルを適用しました。',
  styleStudioApplyScope: '適用先',
  styleStudioScopeBoth: '両方',
  styleStudioScopeMain: 'メイン',
  styleStudioScopeSecond: 'サブ',
  styleStudioCustoms: 'マイスタイル',
  styleStudioCustomsEmpty: 'カスタムスタイルはまだありません — 現在の主トラックの見た目を保存してください。',
  styleStudioCustomName: 'スタイル名',
  styleStudioSave: 'スタイルを保存',
  styleStudioDelete: '削除',
  styleStudioGoogleFonts: 'Google フォント',
  styleStudioGoogleSearch: 'フォントを検索',
  styleStudioGooglePick: 'フォントを検索',
  styleStudioGoogleLoading: 'ロード中...',
  styleStudioGoogleClear: 'Google Font をクリア',
  styleStudioGoogleCurrent: '現在',
  styleStudioGoogleNone: 'このトラックに Google Font はありません（システム/ファミリーのみ）。',
  styleStudioGoogleSubset: '言語',
  styleStudioGoogleSubsetAll: 'すべて',
  styleStudioGoogleNeedFilter: '言語サブセットを選ぶか検索してフォントを表示します。',
  styleStudioGoogleLoadMore: 'さらに表示',
  styleStudioLangBind: 'Styles by language',
  styleStudioLangBindHint:
    'When a subtitle track matches one of these languages, its custom style is applied on the video automatically.',
  styleStudioLangBindNeedCustom: '先にカスタムスタイルを保存してから、ここで言語を紐づけてください。',
  styleStudioLangBindSelectCustom: '言語の紐づけを編集するには、上でカスタムスタイルを選んでください。',
  styleStudioLangSearch: '言語を検索',
  styleStudioLangConflict: '「{name}」で使用中です。',
  styleStudioLangBindEmpty: '言語の紐づけはまだありません。',
  styleStudioBindAdd: '紐づけ',
  styleStudioBindRemove: '削除',
};

const KO: Record<StringKey, string> = {
  appName: 'RikoSub',
  settings: '설정',
  settingsClose: '닫기',
  settingsPosition: '자막 위치',
  settingsStyleMain: '글꼴 - 기본',
  settingsStyleSecond: '글꼴 - 보조',
  settingsPresets: '프리셋',
  settingsLanguage: 'UI 언어',
  settingsSubY: '자막 위치',
  settingsSeparation: '자막 분리 표시',
  settingsSpacing: '간격',
  settingsMaxWidth: '최대 너비',
  settingsFontSize: '글꼴 크기',
  settingsFontColor: '글꼴 색상',
  settingsFontWeight: '글꼴 굵기',
  settingsStroke: '글꼴 외곽선 두께',
  settingsOpacity: '불투명도',
  settingsDarkMode: '다크 모드',
  settingsEngine: '번역 엔진',
  settingsApplyPreset: '적용',
  tracks: '자막 트랙',
  signIn: '로그인',
  member: '멤버',
  account: '계정',
  back: '뒤로',
  settingsPractice: '연습',
  settingsPracticeMode: '모드',
  settingsPracticeWatch: '시청',
  settingsPracticeDictation: '받아쓰기',
  settingsPracticeSpeaking: '말하기',
  settingsPracticeShadowing: '쉐도잉',
  settingsPracticeLearning: '학습',
  settingsShadowingGrayPast: '지난 줄 회색 표시',
  settingsShadowingHideUpcoming: '앞줄 숨기기',
  settingsShadowingAutoRemoveLineBreaks: '줄바꿈 자동 제거',
  settingsDictationSubtitle: '메인 / 보조',
  settingsDictationMain: '메인',
  settingsDictationSecond: '보조',
  settingsDictationFiltered: '필터링된 단어',
  settingsDictationIgnoreBrackets: '괄호 안 텍스트 무시',
  settingsDictationTypingVolume: '타이핑 소리 볼륨',
  settingsDictationInputPosition: '입력 위치',
  settingsDictationPositionTop: '상단',
  settingsDictationPositionBottom: '하단',
  settingsSpeakingVolume: '재생 볼륨',
  settingsFurigana: '후리가나',
  settingsFuriganaEnable: '사용',
  settingsFuriganaConvert: '변환 대상',
  settingsFuriganaRomaji: '로마자',
  settingsReader: '자막 읽기',
  settingsReaderEnable: '사용',
  settingsReaderVoice: '음성',
  settingsReaderVoiceDefault: '자동',
  settingsReaderRate: '속도',
  settingsReaderVolume: '볼륨',
  settingsFontFamily: '글꼴 모음',
  settingsFontGoogleFamilies: 'Google Fonts(글꼴 모음)',
  settingsFontGoogleCss: 'Google Fonts(CSS 속성)',
  settingsFontPreset: '글꼴 모음',
  settingsShadow: '그림자',
  settingsShadowColor: '그림자 색상',
  settingsBackground: '배경색',
  settingsBackgroundOpacity: '배경 불투명도',
  settingsLetterSpacing: '자간',
  settingsLineHeight: '행간',
  settingsPadding: '안쪽 여백',
  settingsBoxShadow: '박스 그림자',
  settingsStrokeColor: '글꼴 외곽선 색상',
  settingsShadowNone: '없음',
  settingsShadowRaised: '돌출',
  settingsShadowDepressed: '음각',
  settingsShadowOutline: '외곽선',
  settingsShadowShadow: '그림자',
  settingsBoxShadowNone: '없음',
  settingsBoxShadowSoft: '부드러움',
  settingsBoxShadowMedium: '중간',
  settingsFontPresetNetflix: 'Netflix Sans',
  settingsFontPresetArial: 'Arial',
  settingsFontPresetVerdana: 'Verdana',
  settingsFontPresetTahoma: 'Tahoma',
  settingsFontPresetTrebuchet: 'Trebuchet MS',
  settingsFontPresetTimes: 'Times New Roman',
  settingsFontPresetGeorgia: 'Georgia',
  settingsFontPresetGaramond: 'Garamond',
  settingsFontPresetCourier: 'Courier New',
  settingsFontPresetBrush: 'Brush Script MT',
  settingsPreprocess: '자막 전처리',
  settingsPreprocess1: '줄바꿈 제거',
  settingsPreprocess2: '괄호 안 텍스트 제거',
  settingsPreprocess3: '시간이 같은 인접 자막 병합',
  settingsEnableShortcuts: '단축키',
  settingsHoverToReveal: '마우스를 올리면 자막 표시',
  settingsSubtitleList: '자막 목록',
  settingsDragHandle: '자막 위치',
  cuePanelTitle: '자막 목록',
  cuePanelSlot: '슬롯',
  cuePanelMain: '메인',
  cuePanelSecond: '보조',
  cuePanelEmpty: '자막 옵션을 선택해 주세요.',
  cueList: '자막 목록',
  settingsLearningTarget: '대상 언어',
  learnTargetNone: '-',
  learnTargetNotSet: '설정 → 연습 → 학습에서 목표 언어를 선택하세요.',
  settingsLearningDefaultPrompt: '기본 프롬프트',
  settingsLearningCardsLink: '링크',
  settingsMainSubY: '자막 위치(메인)',
  settingsSecondSubY: '자막 위치(보조)',
  learnPromptMeaning: '간단한 설명',
  learnPromptExamples: '예문 5개',
  learnPromptDictionary: '사전',
  learnTtsRate: '속도',
  learnTtsRateXslow: '매우 느림',
  learnTtsRateSlow: '느림',
  learnTtsRateMedium: '보통',
  learnUnsave: '카드 삭제',
  learnLoading: '불러오는 중...',
  learnLoadingAi: '불러오는 중...',
  learnQuota: '할당량 한도 도달',
  learnTtsFailed: '실패',
  learnSaveFailed: '오류',
  learnSaving: '저장 중…',
  learnMembersSignIn: '회원 전용 기능',
  learnMembersAi: '회원 전용 기능',
  speakRecord: '녹음',
  speakStop: '중지',
  speakReplay: '녹음 재생',
  speakMic: '마이크',
  speakErrorSecure: '마이크는 HTTPS가 필요합니다. 보안 연결(또는 localhost)로 열어 주세요.',
  speakErrorPermission: '마이크 권한이 거부되었습니다.',
  speakErrorUnsupported: '이 브라우저에서는 녹음을 지원하지 않습니다.',
  speakErrorUnknown: '마이크에 접근할 수 없습니다.',
  practiceNavPrev: '이전',
  practiceNavReplay: '다시 듣기',
  practiceNavNext: '다음',
  cardsTitle: '저장된 카드',
  cardsDeck: '덱',
  cardsSort: '정렬',
  cardsUncategorized: '미분류',
  cardsDeckName: '덱 이름',
  cardsCreateDeck: '덱 만들기',
  cardsRemoveDeck: '덱 삭제',
  cardsDeleteCard: '삭제',
  cardsEditCard: '카드 업데이트',
  cardsExportCsv: '카드 내보내기 (CSV)',
  cardsSave: '제출',
  cardsClose: '닫기',
  cardsFailed: '오류',
  cardsFieldFront: '앞면',
  cardsFieldFrontTrans: '앞면 번역',
  cardsFieldRefSent: '참조 문장',
  cardsFieldRefTrans: '참조 번역',
  cardsFieldFrontDesc: '앞면 메모',
  cardsFieldBackDesc: '뒷면 메모',
  cardsEmpty: '이 덱에 카드가 없습니다.',
  cardsLoading: '불러오는 중...',
  cardsLoginRequired: 'Please log in as a member to view saved cards.',
  cardsDuplicate: '같은 덱이 이미 있습니다',
  cardsRemoveDeckConfirm: '이 덱을 삭제할까요? 안의 카드도 삭제됩니다.',
  cardsRefresh: '새로고침',
  cardsSortCreatedDesc: '생성일 ↓',
  cardsSortCreatedAsc: '생성일 ↑',
  cardsSortUpdatedDesc: '수정일 ↓',
  cardsSortUpdatedAsc: '수정일 ↑',
  shortcutSeekPrev: '이전 자막',
  shortcutSeekRepeat: '자막 반복',
  shortcutSeekNext: '다음 자막',
  shortcutDelayBothDown: '자막 느리게',
  shortcutDelayBothUp: '자막 빠르게',
  shortcutDelayMainDown: '자막 느리게(기본 자막)',
  shortcutDelayMainUp: '자막 빠르게(기본 자막)',
  shortcutDelaySecondDown: '자막 느리게(보조 자막)',
  shortcutDelaySecondUp: '자막 빠르게(보조 자막)',
  shortcutToggleMain: '기본 자막 전환',
  shortcutToggleSecond: '보조 자막 전환',
  shortcutDualMain: '원문 및 번역 표시(기본 자막)',
  shortcutDualSecond: '원문 및 번역 표시(보조 자막)',
  shortcutCopy: '선택한 텍스트 복사',
  shortcutReader: '자막 읽기',
  shortcutDictationHint: '힌트',
  shortcutDictationPlayWord: '현재 단어부터 재생',
  shortcutSpeakingRecord: '녹음(누르고 있기)',
  shortcutSpeakingRecordToggle: '녹음(토글)',
  shortcutSpeakingReplay: '녹음 재생',
  shortcutMic: '마이크 모니터링',
  railSeekPrev: '이전 자막',
  railSeekRepeat: '자막 반복',
  railSeekNext: '다음 자막',
  railPlay: '재생',
  railPause: '일시정지',
  railDelayMain: '주 자막 지연',
  railDelaySecond: '부 자막 지연',
  railDelayDown: '자막 앞당기기(−0.1초)',
  railDelayUp: '자막 늦추기(+0.1초)',
  railPosition: '자막 위치',
  railPositionSlider: '자막 위치',
  railFontSize: '글자 크기',
  railFontSizeSlider: '글자 크기',
  railCenter: '중심선',
  railCenterSlider: '중심선',
  railControls: '컨트롤',
  railPin: '컨트롤 고정',
  langPickerPopular: '자주 쓰는 언어',
  langPickerMore: '더 많은 언어',
  langPickerNone: '번역 없음',
  langPickerCustom: '사용자 코드…',
  langPickerCustomCode: '언어 코드',
  translateTo: '번역 대상',
  trackSelectLabel: '트랙',
  trackSelectPlaceholder: '자막 옵션을 선택해 주세요.',
  trackHide: '기본 자막 숨기기',
  trackLoading: '불러오는 중...',
  trackLoadFailed: '트랙을 불러오지 못했습니다',
  memberTrackHint: '회원 전용 기능',
  trackSource: '소스',
  trackSourceUpload: '업로드',
  trackSourceDemo: '데모 픽스처',
  trackAdvancedShow: '고급 표시…',
  trackAdvancedHide: '고급 숨기기',
  trackEmpty: '이 동영상에 자막 트랙이 없습니다 — 설정에서 파일을 가져오세요(.vtt / .srt / .json3).',
  trackChooseFile: '업로드',
  trackUploadCta: '자막 가져오기',
  trackAddFile: '자막 가져오기',
  trackSlotMain: '메인 자막',
  trackSlotSecond: '보조 자막',
  trackSlotSecondAdvanced: '부 트랙(고급)',
  trackTranslateMain: '메인 자막',
  trackTranslateSecond: '보조 자막',
  trackListing: '불러오는 중...',
  settingsTabSubs: '자막',
  settingsTabPractice: '연습',
  settingsTabLook: '모양',
  settingsTabAdvanced: '기타',
  practiceHintWatch: '일반 이중 자막. 위에서 선택 가능을 켜면 텍스트를 복사할 수 있습니다.',
  practiceHintDictation: '들은 내용을 입력하세요. 각 자막이 끝나면 입력을 마칠 때까지 재생이 일시정지됩니다.',
  practiceHintSpeaking: '각 줄을 소리 내어 말한 뒤 녹음을 확인하세요.',
  practiceHintLearning: '단어를 선택해 조회하고 카드를 저장하세요.',
  practiceEnd: '연습 종료',
  translationStatusBusy: '생성 중 (#)...',
  translationStatusFailed: '실패',
  translationQuota: '할당량 한도 도달',
  translationFailed: '실패',
  translationMemberOnly: '회원 전용 기능',
  serviceLoading: '불러오는 중...',
  serviceQueuing: '대기 중 (#) (@)...',
  serviceGenerating: '생성 중 (#)...',
  serviceDownloading: '다운로드 중...',
  serviceEnhanced: '문장 분할',
  serviceMemberOnly: '회원 전용 기능',
  serviceDismissUnknown: '오류가 발생했습니다. 다시 시도해 주세요',
  serviceDismissInfo: '이 동영상의 자막을 가져올 수 없습니다',
  serviceDismissLength: '동영상이 너무 깁니다',
  serviceDismissLive: '라이브 스트림은 지원되지 않습니다',
  serviceDismissSource: '먼저 원본 자막을 생성하거나 향상하세요',
  serviceDismissEnhance: '향상에 실패했습니다. 다시 시도해 주세요',
  serviceDismissEnhanceTimeout: '향상 시간이 초과되었습니다. 다시 시도해 주세요',
  serviceDismissUpstream: '서버 오류가 발생했습니다. 다시 시도해 주세요',
  serviceDismissCancelled: '취소됨',
  hoverRevealShow: '마우스를 올리면 자막 표시',
  cardsSignInCta: '로그인',
  more: '기타',
  learnSave: '저장',
  learnSaved: '저장됨',
  learnPin: '고정',
  learnUnpin: '고정 해제',
  learnMove: '이동',
  learnSpeak: '읽기',
  learnMembersOnly: '회원 전용 기능',
  recentWatches: '최근',
  recentWatchOpen: '열기',
  subtitleLoadStatus: '불러오는 중...',
  subtitleLoadListing: '불러오는 중...',
  subtitleLoadDownloading: '다운로드 중...',
  practiceWaitingPlayer: '플레이어 대기 중… 동영상이 준비되면 연습 컨트롤이 나타납니다.',
  trackLoadProgress: '진행률',
  dictationPlaceholder: '들은 내용을 입력…',
  dictationPlaceholderSpeaking: '말한 뒤 녹음을 확인…',
  dictationTapToType: '탭하여 입력 시작',
  dictationTapToSpeak: '탭하여 말하기 시작',
  dictationTapToShadow: '탭하여 쉐도잉 시작',
  dictationDone: '완료',
  stageOpenTracks: '트랙 열기',
  stageOpenSettings: '설정 열기',
  stagePickTranslateLang: '이중 자막용 번역 언어를 선택하세요.',
  stageRetryLoad: '다시 시도',
  stageSignIn: '로그인',
  stageDismiss: '닫기',
  stageBilingualSummary: '이중 · {lang}',
  practiceOpen: '시청',
  memberTrackLabel: '회원 전용 기능',
  exportSrt: '자막 내보내기',
  exportSrtMain: '메인 자막',
  exportSrtSecond: '보조 자막',
  exportSrtDone: '다운로드',
  exportSrtNeedTrack: '먼저 자막 트랙을 선택하세요.',
  importSrt: '자막 가져오기',
  importSrtMain: '메인 자막',
  importSrtSecond: '보조 자막',
  importSrtUpload: '업로드',
  importSrtUploaded: '업로드한 자막',
  settingsStyleCopy: '주 자막 스타일 복사',
  settingsStyleCopyFromSecond: '보조 자막 스타일 복사',
  settingsStyleCopyFromMain: '주 자막 스타일 복사',
  settingsStyleResetTrack: '기본값으로 되돌리기',
  settingsStyleSlotMain: '주',
  settingsStyleSlotSecond: '부',
  landingWebDiff: '확장 프로그램과 같은 이중 Tracks. 보안 프록시 자막 · 이메일 로그인 · youtube.com에 주입하지 않음.',
  landingTagline: '모바일 YouTube용 이중 자막.',
  landingUrlLabel: 'YouTube 링크',
  landingOpen: '동영상 열기',
  landingUrlInvalid: '유효한 YouTube URL 또는 동영상 ID를 입력하세요.',
  landingTrySample: '샘플 동영상 체험',
  loginWebDiff: '멤버 기능을 잠금 해제하려면 멤버십에 연결된 이메일로 로그인하세요.',
  loginEmailTitle: 'Login with verification code',
  loginEmailDesc:
    'Enter the email used for your Patreon membership. We will send a one-time code (check spam).',
  loginEmailLabel: 'Email address',
  loginSendCode: 'Send code',
  loginSending: 'Sending…',
  loginCodeLabel: 'Verification code',
  loginSubmit: 'Login',
  loginSubmitting: 'Logging in…',
  loginOr: 'or',
  loginPatreon: 'Patreon으로 로그인',
  loginPatreonNote: '새 탭에서 Patreon을 엽니다. 멤버십이 돌아오지 않으면 위의 이메일 인증을 사용하세요.',
  loginLogout: '로그아웃',
  memberStatusPrefix: '회원 상태:',
  memberStatusActive: '활성',
  memberStatusInactive: '비활성',
  memberStatusSessionExpired: 'Session expired — please log in again',
  memberStatusCheckFailed: '실패',
  memberStatusSignedIn: '로그인됨',
  loginMsgSignedIn: '로그인되었습니다.',
  loginMsgInactive: '로그인됨 — 멤버십 비활성.',
  loginMsgSessionExpired: '로그인됨 — 세션이 만료되었습니다. 다시 로그인해 주세요.',
  loginMsgEmailSent: '이메일을 보냈습니다. 받은편지함(스팸함 포함)을 확인하세요.',
  loginMsgInvalidCode: '유효하지 않거나 이미 사용된 코드입니다.',
  loginMsgNotSubscriber: '구독자가 아닙니다(등록되지 않은 이메일).',
  loginMsgQuotaExceeded: '사용량을 초과했습니다. 나중에 다시 시도하세요.',
  loginMsgRateLimited: '요청이 너무 많습니다. 약 30초 기다려 주세요.',
  loginMsgEnterEmail: '이메일을 입력해 주세요.',
  loginMsgNetworkError: '네트워크 또는 서버 오류.',
  settingsMembersSuffix: ' (멤버)',
  settingsDocs: '문서',
  settingsDocsOpen: '문서',
  settingsStylePreview: '미리보기',
  settingsStylePreviewHint: '주 + 부 · 편집 시 갱신',
  settingsResetAll: '초기화',
  cuePanelLock: '재생 따라가기',
  cuePanelUnlock: '스크롤 잠금 해제',
  cuePanelResize: '자막 목록 크기 조절',
  settingsSelectable: '자막 선택 가능하게 하기',
  settingsSubtitleOptimize: 'AI 문장 분할',
  settingsSubtitleOptimizeEnable: '사용',
  settingsSubtitleOptimizeModel: '모델',
  settingsSubtitleOptimizeModelAuto: '자동',
  settingsSubtitleOptimizeModelSmall: 'Small',
  settingsSubtitleOptimizeModelLarge: 'Large',
  learnCopy: '선택한 텍스트 복사',
  loginCallbackWorking: 'Patreon 로그인 완료 중…',
  loginCallbackOk: '로그인되었습니다. 돌아가는 중…',
  loginCallbackFail: '이 페이지에서 로그인 정보를 읽지 못했습니다. 이메일 인증을 사용하거나 이 리디렉트 URI를 Patreon에 등록하세요.',
  loginCallbackContinue: '계속',
  styleStudioTitle: '자막 스타일 스튜디오',
  styleStudioOpen: '스타일 스튜디오 열기',
  styleStudioApplied: '스타일이 적용되었습니다.',
  styleStudioApplyScope: '적용 대상',
  styleStudioScopeBoth: '둘 다',
  styleStudioScopeMain: '기본',
  styleStudioScopeSecond: '보조',
  styleStudioCustoms: '내 스타일',
  styleStudioCustomsEmpty: '아직 사용자 스타일이 없습니다 — 현재 주 트랙 모양을 저장하세요.',
  styleStudioCustomName: '스타일 이름',
  styleStudioSave: '스타일 저장',
  styleStudioDelete: '삭제',
  styleStudioGoogleFonts: 'Google 폰트',
  styleStudioGoogleSearch: '폰트 검색',
  styleStudioGooglePick: '폰트 검색',
  styleStudioGoogleLoading: '불러오는 중...',
  styleStudioGoogleClear: 'Google Font 지우기',
  styleStudioGoogleCurrent: '현재',
  styleStudioGoogleNone: '이 트랙에 Google Font가 없습니다(시스템/패밀리만).',
  styleStudioGoogleSubset: '언어',
  styleStudioGoogleSubsetAll: '전체',
  styleStudioGoogleNeedFilter: '언어 하위집합을 선택하거나 검색하여 폰트를 표시합니다.',
  styleStudioGoogleLoadMore: '더 보기',
  styleStudioLangBind: 'Styles by language',
  styleStudioLangBindHint:
    'When a subtitle track matches one of these languages, its custom style is applied on the video automatically.',
  styleStudioLangBindNeedCustom: '먼저 사용자 스타일을 저장한 뒤 여기서 언어를 연결하세요.',
  styleStudioLangBindSelectCustom: '언어 연결을 편집하려면 위에서 사용자 스타일을 선택하세요.',
  styleStudioLangSearch: '언어 검색',
  styleStudioLangConflict: '"{name}"에서 이미 사용 중입니다.',
  styleStudioLangBindEmpty: '아직 언어 연결이 없습니다.',
  styleStudioBindAdd: '연결',
  styleStudioBindRemove: '제거',
};

export const STRINGS: Record<UiLocale, Record<StringKey, string>> = {
  en: EN,
  'zh-TW': ZH_TW,
  'zh-CN': ZH_CN,
  ja: JA,
  ko: KO,
};

export const PRESET_LABELS: Record<UiLocale, Record<string, string>> = {
  en: {
    classic: 'Classic box',
    'clean-white': 'TV outline',
    'soft-box': 'Soft box',
    'outline-bold': 'Bold outline',
    'raised-glow': 'Soft shadow',
    'karaoke-yellow': 'Karaoke yellow',
  },
  'zh-TW': {
    classic: '經典底框',
    'clean-white': '黑邊白字',
    'soft-box': '柔和底框',
    'outline-bold': '粗描邊',
    'raised-glow': '柔和陰影',
    'karaoke-yellow': '卡拉OK黃',
  },
  'zh-CN': {
    classic: '经典底框',
    'clean-white': '黑边白字',
    'soft-box': '柔和底框',
    'outline-bold': '粗描边',
    'raised-glow': '柔和阴影',
    'karaoke-yellow': '卡拉OK黄',
  },
  ja: {
    classic: 'クラシック枠',
    'clean-white': 'テレビ字幕',
    'soft-box': 'ソフトボックス',
    'outline-bold': '太い輪郭',
    'raised-glow': 'ソフトシャドウ',
    'karaoke-yellow': 'カラオケ黄',
  },
  ko: {
    classic: '클래식 박스',
    'clean-white': '흑테두리',
    'soft-box': '소프트 박스',
    'outline-bold': '두꺼운 윤곽',
    'raised-glow': '소프트 그림자',
    'karaoke-yellow': '노래방 노랑',
  },
};
